var _excluded = ["active_listing"];
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Summary = require('./summary');
var Listing = require('./listing');
var Database = require('./database');
var _require = require('./ui/summary-cache'),
  syncSummaryCache = _require.syncSummaryCache,
  summaryBucketKey = _require.summaryBucketKey;
var Order = require('./order');
var Slip = require('../../../lib/saito/slip')["default"];
var _require2 = require('saito-js/lib/slip'),
  SlipType = _require2.SlipType;
var _require3 = require('./order'),
  ORDER_STATUS_PENDING = _require3.ORDER_STATUS_PENDING,
  ORDER_STATUS_SETTLING = _require3.ORDER_STATUS_SETTLING,
  ORDER_STATUS_FULFILLED = _require3.ORDER_STATUS_FULFILLED,
  ORDER_STATUS_UNFULFILLABLE = _require3.ORDER_STATUS_UNFULFILLABLE;
var _require4 = require('./helpers'),
  findInventoryTriple = _require4.findInventoryTriple,
  serializeSlip = _require4.serializeSlip,
  normalizeSlipJson = _require4.normalizeSlipJson,
  listingInputSlipJsonFromRecord = _require4.listingInputSlipJsonFromRecord,
  transactionIndexInBlock = _require4.transactionIndexInBlock,
  returnListingSlipId = _require4.returnListingSlipId,
  slipPublicKey = _require4.slipPublicKey;
var _require5 = require('./archive'),
  loadTransactionFromArchive = _require5.loadTransactionFromArchive;
var _require6 = require('./images'),
  initializeImageCache = _require6.initializeImageCache;
var _require7 = require('../../../lib/helpers/security'),
  checkSecurityLevel = _require7.checkSecurityLevel;
var _require8 = require('./scripting'),
  executeListingScript = _require8.executeListingScript,
  returnCreatedNftTuples = _require8.returnCreatedNftTuples,
  returnSpentNftTuples = _require8.returnSpentNftTuples;
var SaitoNFT = require('../../../lib/saito/ui/saito-nft/saito-nft');
var _require9 = require('./categories'),
  mapNFTTypeToCategory = _require9.mapNFTTypeToCategory,
  STORE_CATEGORIES = _require9.STORE_CATEGORIES,
  normalizePageSize = _require9.normalizePageSize,
  normalizeOffset = _require9.normalizeOffset,
  isStoreCategory = _require9.isStoreCategory;
var Warehouse = /*#__PURE__*/function () {
  function Warehouse(app, mod) {
    _classCallCheck(this, Warehouse);
    this.app = app;
    this.mod = mod;
    this.db = new Database(app, mod);
    this.listings = {};
    this.summaries = {};
    // Wind of a block that has no spend rows yet. Drained on the next canonical
    // tip, outside the reorg callback, so the block body can be loaded.
    this.pendingSpendRecovery = [];
    // Serializes summary table + this.summaries / mod.summaries mutations.
    this._summary_mutation_tail = Promise.resolve();
  }

  /**
   * Run fn exclusively against other summary mutations.
   * Non-reentrant: callers must not nest withSummaryMutation.
   */
  return _createClass(Warehouse, [{
    key: "withSummaryMutation",
    value: function withSummaryMutation(fn) {
      var run = this._summary_mutation_tail.then(function () {
        return fn();
      });
      this._summary_mutation_tail = run.then(function () {
        return undefined;
      }, function () {
        return undefined;
      });
      return run;
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return this.db.ensureSchema();
            case 2:
              this.mod.summaries = {};
              _context.n = 3;
              return this.initializeSummaryCache();
            case 3:
              _context.n = 4;
              return initializeImageCache(this.mod);
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "initializeSummaryCache",
    value: function () {
      var _initializeSummaryCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              return _context3.a(2, this.withSummaryMutation(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var buckets, _iterator, _step, bucket, rows, _iterator2, _step2, row, key, _t, _t2;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.p = _context2.n) {
                    case 0:
                      _context2.n = 1;
                      return _this.db.scanListingsForSummaryRebuild();
                    case 1:
                      buckets = _context2.v;
                      _iterator = _createForOfIteratorHelper(buckets || []);
                      _context2.p = 2;
                      _iterator.s();
                    case 3:
                      if ((_step = _iterator.n()).done) {
                        _context2.n = 5;
                        break;
                      }
                      bucket = _step.value;
                      _context2.n = 4;
                      return _this._syncSummaryForBucket(bucket.nft_id, bucket.price);
                    case 4:
                      _context2.n = 3;
                      break;
                    case 5:
                      _context2.n = 7;
                      break;
                    case 6:
                      _context2.p = 6;
                      _t = _context2.v;
                      _iterator.e(_t);
                    case 7:
                      _context2.p = 7;
                      _iterator.f();
                      return _context2.f(7);
                    case 8:
                      _context2.n = 9;
                      return _this.db.loadAllSummaries();
                    case 9:
                      rows = _context2.v;
                      _iterator2 = _createForOfIteratorHelper(rows || []);
                      _context2.p = 10;
                      _iterator2.s();
                    case 11:
                      if ((_step2 = _iterator2.n()).done) {
                        _context2.n = 13;
                        break;
                      }
                      row = _step2.value;
                      key = summaryBucketKey(row.nft_id, row.price);
                      if (_this.summaries[key]) {
                        _context2.n = 12;
                        break;
                      }
                      _context2.n = 12;
                      return _this._syncSummaryToCache(row.nft_id, row.price);
                    case 12:
                      _context2.n = 11;
                      break;
                    case 13:
                      _context2.n = 15;
                      break;
                    case 14:
                      _context2.p = 14;
                      _t2 = _context2.v;
                      _iterator2.e(_t2);
                    case 15:
                      _context2.p = 15;
                      _iterator2.f();
                      return _context2.f(15);
                    case 16:
                      _this.mod.summaries = _this.summaries;
                    case 17:
                      return _context2.a(2);
                  }
                }, _callee2, null, [[10, 14, 15, 16], [2, 6, 7, 8]]);
              }))));
          }
        }, _callee3, this);
      }));
      function initializeSummaryCache() {
        return _initializeSummaryCache.apply(this, arguments);
      }
      return initializeSummaryCache;
    }()
  }, {
    key: "onNewBlock",
    value: function () {
      var _onNewBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(blk, lc) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (lc) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return this.finishDeferredSpendRecovery();
            case 2:
              _context4.n = 3;
              return this.processQueue();
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onNewBlock(_x, _x2) {
        return _onNewBlock.apply(this, arguments);
      }
      return onNewBlock;
    }()
  }, {
    key: "onChainReorganization",
    value: function () {
      var _onChainReorganization = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(block_id, block_hash, longest_chain) {
        var reveal_listings, existing_sales, existing_listings, _i, _Object$values, _row$block_id_listed, _row$block_hash_liste, row, listed, sold, sales, _iterator3, _step3, _fresh$block_id_sold, _fresh$transaction_id, _fresh$longest_chain_, _fresh$longest_chain_2, _fresh$settlement_pen, _fresh$quantity_sold, sale, key, cached, fresh, buckets, _iterator4, _step4, bucket, _t3, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              // A missing spend row must be rebuilt from the block before inclusions
              // created in that block become visible. The reorg callback has no block
              // body, so reveal waits until finishDeferredSpendRecovery.
              reveal_listings = true;
              if (!longest_chain) {
                _context5.n = 3;
                break;
              }
              _context5.n = 1;
              return this.db.countListingSalesForBlock(block_id, block_hash);
            case 1:
              existing_sales = _context5.v;
              _context5.n = 2;
              return this.db.countListingsInBlock(block_id, block_hash);
            case 2:
              existing_listings = _context5.v;
              // First inclusion has no rows yet; confirmation writes the spend and the
              // remainder. A returning block already has rows, and confirmation will
              // not run again. Rebuild a missing spend before those rows are shown.
              if (existing_sales === 0 && existing_listings > 0) {
                this.pendingSpendRecovery.push({
                  block_id: Number(block_id) || 0,
                  block_hash: String(block_hash || '')
                });
                reveal_listings = false;
              }
            case 3:
              _context5.n = 4;
              return this.db.applyListingChainReorganization(block_id, block_hash, longest_chain, reveal_listings);
            case 4:
              _context5.n = 5;
              return this.db.updateOrdersReceivedChainState(block_id, block_hash, longest_chain);
            case 5:
              _context5.n = 6;
              return this.db.updateOrdersFulfilledChainState(block_id, block_hash, longest_chain);
            case 6:
              for (_i = 0, _Object$values = Object.values(this.listings); _i < _Object$values.length; _i++) {
                row = _Object$values[_i];
                listed = Number((_row$block_id_listed = row.block_id_listed) !== null && _row$block_id_listed !== void 0 ? _row$block_id_listed : row.block_id) === Number(block_id) && String(((_row$block_hash_liste = row.block_hash_listed) !== null && _row$block_hash_liste !== void 0 ? _row$block_hash_liste : row.block_hash) || '') === String(block_hash || '');
                sold = Number(row.block_id_sold) === Number(block_id) && String(row.block_hash_sold || '') === String(block_hash || '');
                if (listed && (!longest_chain || reveal_listings)) {
                  row.longest_chain_listed = longest_chain ? 1 : 0;
                }
                // Snapshot chain flag only. Sale identity stays so a later wind can match.
                if (sold) {
                  row.longest_chain_sold = longest_chain ? 1 : 0;
                }
              }
              _context5.n = 7;
              return this.db.returnListingSalesForBlock(block_id, block_hash);
            case 7:
              sales = _context5.v;
              _iterator3 = _createForOfIteratorHelper(sales || []);
              _context5.p = 8;
              _iterator3.s();
            case 9:
              if ((_step3 = _iterator3.n()).done) {
                _context5.n = 14;
                break;
              }
              sale = _step3.value;
              key = this.listingCacheKey(sale.signature, sale.block_hash_listed);
              cached = this.listings[key];
              if (cached) {
                _context5.n = 10;
                break;
              }
              return _context5.a(3, 13);
            case 10:
              _context5.n = 11;
              return this.db.returnListingBySignatureAndBlockHash(sale.signature, sale.block_hash_listed);
            case 11:
              fresh = _context5.v;
              if (fresh) {
                _context5.n = 12;
                break;
              }
              return _context5.a(3, 13);
            case 12:
              cached.block_id_sold = Number((_fresh$block_id_sold = fresh.block_id_sold) !== null && _fresh$block_id_sold !== void 0 ? _fresh$block_id_sold : 0);
              cached.block_hash_sold = fresh.block_hash_sold || '';
              cached.transaction_id_sold = Number((_fresh$transaction_id = fresh.transaction_id_sold) !== null && _fresh$transaction_id !== void 0 ? _fresh$transaction_id : 0);
              cached.longest_chain_sold = Number((_fresh$longest_chain_ = fresh.longest_chain_sold) !== null && _fresh$longest_chain_ !== void 0 ? _fresh$longest_chain_ : 0);
              cached.longest_chain_listed = Number((_fresh$longest_chain_2 = fresh.longest_chain_listed) !== null && _fresh$longest_chain_2 !== void 0 ? _fresh$longest_chain_2 : 0);
              cached.settlement_pending = Number((_fresh$settlement_pen = fresh.settlement_pending) !== null && _fresh$settlement_pen !== void 0 ? _fresh$settlement_pen : 0) ? 1 : 0;
              cached.buyer = fresh.buyer || '';
              cached.quantity_sold = Number((_fresh$quantity_sold = fresh.quantity_sold) !== null && _fresh$quantity_sold !== void 0 ? _fresh$quantity_sold : 0);
            case 13:
              _context5.n = 9;
              break;
            case 14:
              _context5.n = 16;
              break;
            case 15:
              _context5.p = 15;
              _t3 = _context5.v;
              _iterator3.e(_t3);
            case 16:
              _context5.p = 16;
              _iterator3.f();
              return _context5.f(16);
            case 17:
              _context5.n = 18;
              return this.db.returnBucketsAffectedByBlock(block_id, block_hash);
            case 18:
              buckets = _context5.v;
              _iterator4 = _createForOfIteratorHelper(buckets || []);
              _context5.p = 19;
              _iterator4.s();
            case 20:
              if ((_step4 = _iterator4.n()).done) {
                _context5.n = 22;
                break;
              }
              bucket = _step4.value;
              _context5.n = 21;
              return this.syncSummaryForBucket(bucket.nft_id, bucket.price);
            case 21:
              _context5.n = 20;
              break;
            case 22:
              _context5.n = 24;
              break;
            case 23:
              _context5.p = 23;
              _t4 = _context5.v;
              _iterator4.e(_t4);
            case 24:
              _context5.p = 24;
              _iterator4.f();
              return _context5.f(24);
            case 25:
              return _context5.a(2);
          }
        }, _callee5, this, [[19, 23, 24, 25], [8, 15, 16, 17]]);
      }));
      function onChainReorganization(_x3, _x4, _x5) {
        return _onChainReorganization.apply(this, arguments);
      }
      return onChainReorganization;
    }() // --- listings ---
    /** Cache key for one block inclusion of a listing transaction. */
  }, {
    key: "listingCacheKey",
    value: function listingCacheKey(signature) {
      var block_hash_listed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return "".concat(String(signature || ''), ":").concat(String(block_hash_listed || ''));
    }
  }, {
    key: "addListing",
    value: function () {
      var _addListing = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(nftOrRow) {
        var tx,
          txmsg,
          blk,
          row,
          listing,
          key,
          _args6 = arguments,
          _t5,
          _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              tx = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : null;
              txmsg = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : null;
              blk = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : null;
              if (!this.app.BROWSER) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, null);
            case 1:
              if (!(tx && txmsg)) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2, this.addListingFromTransaction(nftOrRow, tx, txmsg, blk));
            case 2:
              row = nftOrRow;
              _t5 = !(row !== null && row !== void 0 && row.signature);
              if (_t5) {
                _context6.n = 4;
                break;
              }
              _context6.n = 3;
              return this.listingExists(row.signature, row.block_hash_listed);
            case 3:
              _t5 = _context6.v;
            case 4:
              if (!_t5) {
                _context6.n = 5;
                break;
              }
              return _context6.a(2, null);
            case 5:
              listing = new Listing(row);
              key = this.listingCacheKey(listing.signature, listing.block_hash_listed);
              this.listings[key] = listing;
              _context6.p = 6;
              _context6.n = 7;
              return this.db.insertListingRow(listing);
            case 7:
              _context6.n = 10;
              break;
            case 8:
              _context6.p = 8;
              _t6 = _context6.v;
              delete this.listings[key];
              if (!String((_t6 === null || _t6 === void 0 ? void 0 : _t6.message) || _t6).includes('UNIQUE')) {
                _context6.n = 9;
                break;
              }
              return _context6.a(2, null);
            case 9:
              throw _t6;
            case 10:
              return _context6.a(2, listing);
          }
        }, _callee6, this, [[6, 8]]);
      }));
      function addListing(_x6) {
        return _addListing.apply(this, arguments);
      }
      return addListing;
    }()
  }, {
    key: "removeListing",
    value: function () {
      var _removeListing = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(nftOrRows) {
        var tx,
          txmsg,
          blk,
          spent_rows,
          now,
          removed,
          _iterator5,
          _step5,
          _blk$id,
          _blk$hash,
          _row$quantity,
          row,
          listing_row,
          sold_block_id,
          sold_block_hash,
          sold_transaction_id,
          _args7 = arguments,
          _t7;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              tx = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : null;
              txmsg = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : null;
              blk = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : null;
              if (!this.app.BROWSER) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, []);
            case 1:
              spent_rows = [];
              if (!tx) {
                _context7.n = 3;
                break;
              }
              _context7.n = 2;
              return this.matchSpentListings(tx);
            case 2:
              spent_rows = _context7.v;
              _context7.n = 4;
              break;
            case 3:
              if (Array.isArray(nftOrRows)) {
                spent_rows = nftOrRows;
              } else if (nftOrRows !== null && nftOrRows !== void 0 && nftOrRows.signature) {
                spent_rows = [nftOrRows];
              }
            case 4:
              if (spent_rows.length) {
                _context7.n = 5;
                break;
              }
              return _context7.a(2, []);
            case 5:
              now = Date.now();
              removed = [];
              _iterator5 = _createForOfIteratorHelper(spent_rows);
              _context7.p = 6;
              _iterator5.s();
            case 7:
              if ((_step5 = _iterator5.n()).done) {
                _context7.n = 12;
                break;
              }
              row = _step5.value;
              listing_row = new Listing(row);
              if (!listing_row.isSoldOnChain()) {
                _context7.n = 8;
                break;
              }
              return _context7.a(3, 11);
            case 8:
              sold_block_id = Number((_blk$id = blk === null || blk === void 0 ? void 0 : blk.id) !== null && _blk$id !== void 0 ? _blk$id : 0);
              sold_block_hash = String((_blk$hash = blk === null || blk === void 0 ? void 0 : blk.hash) !== null && _blk$hash !== void 0 ? _blk$hash : '');
              sold_transaction_id = transactionIndexInBlock(blk, tx);
              _context7.n = 9;
              return this.db.markListingSold(row.signature, {
                block_hash_listed: listing_row.block_hash_listed,
                sold_block_id: sold_block_id,
                sold_block_hash: sold_block_hash,
                sold_transaction_id: sold_transaction_id,
                quantity_sold: Math.max(0, Number((_row$quantity = row.quantity) !== null && _row$quantity !== void 0 ? _row$quantity : 0) || 0),
                sold_at: now
              }, now);
            case 9:
              delete this.listings[this.listingCacheKey(row.signature, listing_row.block_hash_listed)];
              _context7.n = 10;
              return this.syncSummaryForBucket(row.nft_id, row.price);
            case 10:
              removed.push(row);
            case 11:
              _context7.n = 7;
              break;
            case 12:
              _context7.n = 14;
              break;
            case 13:
              _context7.p = 13;
              _t7 = _context7.v;
              _iterator5.e(_t7);
            case 14:
              _context7.p = 14;
              _iterator5.f();
              return _context7.f(14);
            case 15:
              return _context7.a(2, removed);
          }
        }, _callee7, this, [[6, 13, 14, 15]]);
      }));
      function removeListing(_x7) {
        return _removeListing.apply(this, arguments);
      }
      return removeListing;
    }()
    /**
     * Seller delist: reuse markListingSold with buyer=seller so Sales can exclude self-sales.
     * Preserves sold-chain anchors for existing reorg handling.
     */
  }, {
    key: "consumeDelistedListing",
    value: function () {
      var _consumeDelistedListing = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(row) {
        var _blk$id2, _blk$hash2, _row$quantity2;
        var tx,
          blk,
          listing_row,
          seller,
          now,
          sold_block_id,
          sold_block_hash,
          sold_transaction_id,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              tx = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : null;
              blk = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : null;
              if (!(this.app.BROWSER || !(row !== null && row !== void 0 && row.signature))) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, null);
            case 1:
              listing_row = new Listing(row);
              if (!listing_row.isSoldOnChain()) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2, null);
            case 2:
              seller = String(row.seller || '').trim();
              now = Date.now();
              sold_block_id = Number((_blk$id2 = blk === null || blk === void 0 ? void 0 : blk.id) !== null && _blk$id2 !== void 0 ? _blk$id2 : 0);
              sold_block_hash = String((_blk$hash2 = blk === null || blk === void 0 ? void 0 : blk.hash) !== null && _blk$hash2 !== void 0 ? _blk$hash2 : '');
              sold_transaction_id = transactionIndexInBlock(blk, tx);
              _context8.n = 3;
              return this.db.markListingSold(row.signature, {
                block_hash_listed: listing_row.block_hash_listed,
                sold_block_id: sold_block_id,
                sold_block_hash: sold_block_hash,
                sold_transaction_id: sold_transaction_id,
                buyer: seller,
                note: '',
                quantity_sold: Math.max(0, Number((_row$quantity2 = row.quantity) !== null && _row$quantity2 !== void 0 ? _row$quantity2 : 0) || 0),
                sold_at: now
              }, now);
            case 3:
              delete this.listings[this.listingCacheKey(row.signature, listing_row.block_hash_listed)];
              _context8.n = 4;
              return this.syncSummaryForBucket(row.nft_id, row.price);
            case 4:
              return _context8.a(2, row);
          }
        }, _callee8, this);
      }));
      function consumeDelistedListing(_x8) {
        return _consumeDelistedListing.apply(this, arguments);
      }
      return consumeDelistedListing;
    }() // --- orders ---
    /** Returns false when this inclusion of the purchase is already on record. */
  }, {
    key: "addOrder",
    value: function () {
      var _addOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(order) {
        var params, _t8;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              params = order instanceof Order ? order.toInsertParams() : order;
              _context9.n = 1;
              return this.db.insertOrder(params);
            case 1:
              _t8 = _context9.v;
              return _context9.a(2, _t8 > 0);
          }
        }, _callee9, this);
      }));
      function addOrder(_x9) {
        return _addOrder.apply(this, arguments);
      }
      return addOrder;
    }()
  }, {
    key: "confirmSettlement",
    value: function () {
      var _confirmSettlement = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(blk, tx) {
        var _tx$returnMessage, _blk$id3, _blk$hash3;
        var txmsg, fulfill, order_row, order, fulfilled_block_id, fulfilled_block_hash, fulfilled_transaction_id, _t9;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (!(this.app.BROWSER || !(tx !== null && tx !== void 0 && tx.signature))) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              txmsg = ((_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || {};
              fulfill = txmsg.fulfill_sale;
              if (fulfill !== null && fulfill !== void 0 && fulfill.sale_signature) {
                _context0.n = 2;
                break;
              }
              return _context0.a(2);
            case 2:
              _context0.n = 3;
              return this.db.returnOrderBySettlementSig(tx.signature);
            case 3:
              _t9 = _context0.v;
              if (_t9) {
                _context0.n = 5;
                break;
              }
              _context0.n = 4;
              return this.db.returnOrderByTxSig(fulfill.sale_signature);
            case 4:
              _t9 = _context0.v;
            case 5:
              order_row = _t9;
              order = order_row ? new Order(order_row) : null;
              _context0.n = 6;
              return this.recordFulfillmentSpends(blk, tx, {
                buyer: (order === null || order === void 0 ? void 0 : order.buyer) || fulfill.buyer || '',
                note: (order === null || order === void 0 ? void 0 : order.note) || '',
                quantity: order ? Number(order.quantity) || 1 : null
              });
            case 6:
              if (order) {
                _context0.n = 7;
                break;
              }
              return _context0.a(2);
            case 7:
              fulfilled_block_id = Number((_blk$id3 = blk === null || blk === void 0 ? void 0 : blk.id) !== null && _blk$id3 !== void 0 ? _blk$id3 : 0);
              fulfilled_block_hash = String((_blk$hash3 = blk === null || blk === void 0 ? void 0 : blk.hash) !== null && _blk$hash3 !== void 0 ? _blk$hash3 : '');
              fulfilled_transaction_id = transactionIndexInBlock(blk, tx); // Same canonical inclusion already recorded. A replay after reorg has a new
              // block hash and longest_chain_fulfilled = 0, so settlement runs again.
              if (!(order.isFulfilledOnChain() && order.block_hash_fulfilled === fulfilled_block_hash && order.settlement_tx_sig === tx.signature)) {
                _context0.n = 8;
                break;
              }
              return _context0.a(2);
            case 8:
              _context0.n = 9;
              return this.db.updateOrder(order.id, {
                status: ORDER_STATUS_FULFILLED,
                block_id_fulfilled: fulfilled_block_id,
                block_hash_fulfilled: fulfilled_block_hash,
                transaction_id_fulfilled: fulfilled_transaction_id,
                longest_chain_fulfilled: 1
              });
            case 9:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function confirmSettlement(_x0, _x1) {
        return _confirmSettlement.apply(this, arguments);
      }
      return confirmSettlement;
    }()
    /**
     * A fulfillment consumes the listing inclusion whose three stored slips match
     * the transaction inputs by block id, tx ordinal, and slip index. The listing
     * signature is not the match key: two inclusions of one transaction have
     * different outpoints, and only the spent one is recorded.
     */
  }, {
    key: "returnTransactionMessage",
    value: function returnTransactionMessage(tx) {
      try {
        if (typeof (tx === null || tx === void 0 ? void 0 : tx.returnMessage) === 'function') {
          return tx.returnMessage() || {};
        }
        if (tx !== null && tx !== void 0 && tx.msg && _typeof(tx.msg) === 'object') {
          return tx.msg;
        }
        if (tx !== null && tx !== void 0 && tx.data && tx.data.byteLength > 0) {
          return JSON.parse(Buffer.from(tx.data).toString('utf-8'));
        }
      } catch (err) {
        return {};
      }
      return {};
    }
  }, {
    key: "listingOutpointsSpentBy",
    value: function listingOutpointsSpentBy(row, tx) {
      var slip_json = listingInputSlipJsonFromRecord(row);
      if (!slip_json) {
        return false;
      }
      var anchored = slip_json.map(function (data) {
        return new Slip(undefined, normalizeSlipJson(data));
      });
      return anchored.every(function (expected) {
        return (tx.from || []).some(function (input) {
          var _ref2, _input$blockId, _expected$blockId, _ref3, _input$txOrdinal, _expected$txOrdinal, _input$index, _expected$index;
          return Number((_ref2 = (_input$blockId = input === null || input === void 0 ? void 0 : input.blockId) !== null && _input$blockId !== void 0 ? _input$blockId : input === null || input === void 0 ? void 0 : input.block_id) !== null && _ref2 !== void 0 ? _ref2 : 0) === Number((_expected$blockId = expected.blockId) !== null && _expected$blockId !== void 0 ? _expected$blockId : 0) && Number((_ref3 = (_input$txOrdinal = input === null || input === void 0 ? void 0 : input.txOrdinal) !== null && _input$txOrdinal !== void 0 ? _input$txOrdinal : input === null || input === void 0 ? void 0 : input.tx_ordinal) !== null && _ref3 !== void 0 ? _ref3 : 0) === Number((_expected$txOrdinal = expected.txOrdinal) !== null && _expected$txOrdinal !== void 0 ? _expected$txOrdinal : 0) && Number((_input$index = input === null || input === void 0 ? void 0 : input.index) !== null && _input$index !== void 0 ? _input$index : 0) === Number((_expected$index = expected.index) !== null && _expected$index !== void 0 ? _expected$index : 0);
        });
      });
    }
  }, {
    key: "recordFulfillmentSpends",
    value: function () {
      var _recordFulfillmentSpends = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(blk, tx) {
        var _this2 = this,
          _blk$id4,
          _blk$hash4;
        var sale,
          rows,
          matched,
          sold_block_id,
          sold_block_hash,
          sold_transaction_id,
          now,
          remaining,
          touched,
          _iterator6,
          _step6,
          _row$quantity3,
          row,
          row_qty,
          quantity_sold,
          buckets,
          _iterator7,
          _step7,
          key,
          _key$split,
          _key$split2,
          nft_id,
          price,
          _args1 = arguments,
          _t0,
          _t1;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              sale = _args1.length > 2 && _args1[2] !== undefined ? _args1[2] : {};
              _context1.n = 1;
              return this.db.returnListingRowsForSpendMatch();
            case 1:
              rows = _context1.v;
              matched = (rows || []).filter(function (row) {
                return _this2.listingOutpointsSpentBy(row, tx);
              });
              if (matched.length) {
                _context1.n = 2;
                break;
              }
              console.warn('Store: fulfillment inputs did not match a stored listing inclusion', tx.signature);
              return _context1.a(2, []);
            case 2:
              sold_block_id = Number((_blk$id4 = blk === null || blk === void 0 ? void 0 : blk.id) !== null && _blk$id4 !== void 0 ? _blk$id4 : 0);
              sold_block_hash = String((_blk$hash4 = blk === null || blk === void 0 ? void 0 : blk.hash) !== null && _blk$hash4 !== void 0 ? _blk$hash4 : '');
              sold_transaction_id = transactionIndexInBlock(blk, tx);
              now = Date.now();
              remaining = sale.quantity == null ? null : Math.max(0, Number(sale.quantity) || 0);
              touched = [];
              _iterator6 = _createForOfIteratorHelper(matched);
              _context1.p = 3;
              _iterator6.s();
            case 4:
              if ((_step6 = _iterator6.n()).done) {
                _context1.n = 7;
                break;
              }
              row = _step6.value;
              row_qty = Math.max(1, Number((_row$quantity3 = row.quantity) !== null && _row$quantity3 !== void 0 ? _row$quantity3 : 1) || 1);
              quantity_sold = remaining == null ? row_qty : Math.min(row_qty, Math.max(0, remaining));
              if (remaining != null) {
                remaining = Math.max(0, remaining - quantity_sold);
              }
              _context1.n = 5;
              return this.db.markListingSold(row.signature, {
                block_hash_listed: row.block_hash_listed,
                sold_block_id: sold_block_id,
                sold_block_hash: sold_block_hash,
                sold_transaction_id: sold_transaction_id,
                note: sale.note || '',
                buyer: sale.buyer || '',
                quantity_sold: quantity_sold,
                sold_at: now
              }, now);
            case 5:
              delete this.listings[this.listingCacheKey(row.signature, row.block_hash_listed)];
              touched.push(row);
            case 6:
              _context1.n = 4;
              break;
            case 7:
              _context1.n = 9;
              break;
            case 8:
              _context1.p = 8;
              _t0 = _context1.v;
              _iterator6.e(_t0);
            case 9:
              _context1.p = 9;
              _iterator6.f();
              return _context1.f(9);
            case 10:
              buckets = new Set(touched.map(function (row) {
                return "".concat(row.nft_id, "\0").concat(row.price);
              }));
              _iterator7 = _createForOfIteratorHelper(buckets);
              _context1.p = 11;
              _iterator7.s();
            case 12:
              if ((_step7 = _iterator7.n()).done) {
                _context1.n = 14;
                break;
              }
              key = _step7.value;
              _key$split = key.split('\0'), _key$split2 = _slicedToArray(_key$split, 2), nft_id = _key$split2[0], price = _key$split2[1];
              _context1.n = 13;
              return this.syncSummaryForBucket(nft_id, price);
            case 13:
              _context1.n = 12;
              break;
            case 14:
              _context1.n = 16;
              break;
            case 15:
              _context1.p = 15;
              _t1 = _context1.v;
              _iterator7.e(_t1);
            case 16:
              _context1.p = 16;
              _iterator7.f();
              return _context1.f(16);
            case 17:
              return _context1.a(2, touched);
          }
        }, _callee1, this, [[11, 15, 16, 17], [3, 8, 9, 10]]);
      }));
      function recordFulfillmentSpends(_x10, _x11) {
        return _recordFulfillmentSpends.apply(this, arguments);
      }
      return recordFulfillmentSpends;
    }()
    /**
     * Blocks wound with no spend rows stay hidden until this runs. It loads each
     * block, writes sale inclusions from the outpoint match, then reveals listing
     * inclusions created in that block. Sale canonicality is written first.
     */
  }, {
    key: "finishDeferredSpendRecovery",
    value: function () {
      var _finishDeferredSpendRecovery = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var pending, retry, _iterator8, _step8, item, recorded, _i2, _Object$values2, _row$block_id_listed2, _row$block_hash_liste2, row, listed, sales, _iterator9, _step9, _fresh$block_id_sold2, _fresh$transaction_id2, _fresh$longest_chain_3, _fresh$settlement_pen2, _fresh$quantity_sold2, sale, key, cached, fresh, buckets, _iterator0, _step0, bucket, _this$pendingSpendRec, _t10, _t11, _t12;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              if (!(this.app.BROWSER || !this.pendingSpendRecovery.length)) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2);
            case 1:
              pending = this.pendingSpendRecovery.splice(0);
              retry = [];
              _iterator8 = _createForOfIteratorHelper(pending);
              _context10.p = 2;
              _iterator8.s();
            case 3:
              if ((_step8 = _iterator8.n()).done) {
                _context10.n = 26;
                break;
              }
              item = _step8.value;
              _context10.n = 4;
              return this.recoverMissingFulfillmentSpends(item.block_id, item.block_hash);
            case 4:
              recorded = _context10.v;
              if (recorded) {
                _context10.n = 5;
                break;
              }
              retry.push(item);
              return _context10.a(3, 25);
            case 5:
              _context10.n = 6;
              return this.db.revealListingsInBlock(item.block_id, item.block_hash);
            case 6:
              for (_i2 = 0, _Object$values2 = Object.values(this.listings); _i2 < _Object$values2.length; _i2++) {
                row = _Object$values2[_i2];
                listed = Number((_row$block_id_listed2 = row.block_id_listed) !== null && _row$block_id_listed2 !== void 0 ? _row$block_id_listed2 : row.block_id) === Number(item.block_id) && String(((_row$block_hash_liste2 = row.block_hash_listed) !== null && _row$block_hash_liste2 !== void 0 ? _row$block_hash_liste2 : row.block_hash) || '') === String(item.block_hash || '');
                if (listed) {
                  row.longest_chain_listed = 1;
                }
              }
              _context10.n = 7;
              return this.db.returnListingSalesForBlock(item.block_id, item.block_hash);
            case 7:
              sales = _context10.v;
              _iterator9 = _createForOfIteratorHelper(sales || []);
              _context10.p = 8;
              _iterator9.s();
            case 9:
              if ((_step9 = _iterator9.n()).done) {
                _context10.n = 14;
                break;
              }
              sale = _step9.value;
              key = this.listingCacheKey(sale.signature, sale.block_hash_listed);
              cached = this.listings[key];
              if (cached) {
                _context10.n = 10;
                break;
              }
              return _context10.a(3, 13);
            case 10:
              _context10.n = 11;
              return this.db.returnListingBySignatureAndBlockHash(sale.signature, sale.block_hash_listed);
            case 11:
              fresh = _context10.v;
              if (fresh) {
                _context10.n = 12;
                break;
              }
              return _context10.a(3, 13);
            case 12:
              cached.block_id_sold = Number((_fresh$block_id_sold2 = fresh.block_id_sold) !== null && _fresh$block_id_sold2 !== void 0 ? _fresh$block_id_sold2 : 0);
              cached.block_hash_sold = fresh.block_hash_sold || '';
              cached.transaction_id_sold = Number((_fresh$transaction_id2 = fresh.transaction_id_sold) !== null && _fresh$transaction_id2 !== void 0 ? _fresh$transaction_id2 : 0);
              cached.longest_chain_sold = Number((_fresh$longest_chain_3 = fresh.longest_chain_sold) !== null && _fresh$longest_chain_3 !== void 0 ? _fresh$longest_chain_3 : 0);
              cached.settlement_pending = Number((_fresh$settlement_pen2 = fresh.settlement_pending) !== null && _fresh$settlement_pen2 !== void 0 ? _fresh$settlement_pen2 : 0) ? 1 : 0;
              cached.buyer = fresh.buyer || '';
              cached.quantity_sold = Number((_fresh$quantity_sold2 = fresh.quantity_sold) !== null && _fresh$quantity_sold2 !== void 0 ? _fresh$quantity_sold2 : 0);
            case 13:
              _context10.n = 9;
              break;
            case 14:
              _context10.n = 16;
              break;
            case 15:
              _context10.p = 15;
              _t10 = _context10.v;
              _iterator9.e(_t10);
            case 16:
              _context10.p = 16;
              _iterator9.f();
              return _context10.f(16);
            case 17:
              _context10.n = 18;
              return this.db.returnBucketsAffectedByBlock(item.block_id, item.block_hash);
            case 18:
              buckets = _context10.v;
              _iterator0 = _createForOfIteratorHelper(buckets || []);
              _context10.p = 19;
              _iterator0.s();
            case 20:
              if ((_step0 = _iterator0.n()).done) {
                _context10.n = 22;
                break;
              }
              bucket = _step0.value;
              _context10.n = 21;
              return this.syncSummaryForBucket(bucket.nft_id, bucket.price);
            case 21:
              _context10.n = 20;
              break;
            case 22:
              _context10.n = 24;
              break;
            case 23:
              _context10.p = 23;
              _t11 = _context10.v;
              _iterator0.e(_t11);
            case 24:
              _context10.p = 24;
              _iterator0.f();
              return _context10.f(24);
            case 25:
              _context10.n = 3;
              break;
            case 26:
              _context10.n = 28;
              break;
            case 27:
              _context10.p = 27;
              _t12 = _context10.v;
              _iterator8.e(_t12);
            case 28:
              _context10.p = 28;
              _iterator8.f();
              return _context10.f(28);
            case 29:
              if (retry.length) {
                (_this$pendingSpendRec = this.pendingSpendRecovery).unshift.apply(_this$pendingSpendRec, retry);
              }
            case 30:
              return _context10.a(2);
          }
        }, _callee10, this, [[19, 23, 24, 25], [8, 15, 16, 17], [2, 27, 28, 29]]);
      }));
      function finishDeferredSpendRecovery() {
        return _finishDeferredSpendRecovery.apply(this, arguments);
      }
      return finishDeferredSpendRecovery;
    }()
    /**
     * A block is on the longest chain but this process never wrote its spend rows.
     * Replay the block's fulfillment transactions through the same outpoint match.
     * Returns false when the block could not be loaded, so the caller does not
     * reveal remainder inclusions before the spend exists.
     * Ordinary reorg of an existing spend only flips longest_chain_sold.
     */
  }, {
    key: "recoverMissingFulfillmentSpends",
    value: function () {
      var _recoverMissingFulfillmentSpends = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(block_id, block_hash) {
        var _block;
        var existing, block, _this$app$core, transactions, _iterator1, _step1, tx, txmsg, _t13, _t14;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              if (!(this.app.BROWSER || !block_hash)) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2, false);
            case 1:
              _context11.n = 2;
              return this.db.countListingSalesForBlock(block_id, block_hash);
            case 2:
              existing = _context11.v;
              if (!(existing > 0)) {
                _context11.n = 3;
                break;
              }
              return _context11.a(2, true);
            case 3:
              block = null;
              _context11.p = 4;
              _context11.n = 5;
              return (_this$app$core = this.app.core) === null || _this$app$core === void 0 || (_this$app$core = _this$app$core.blockchain) === null || _this$app$core === void 0 ? void 0 : _this$app$core.getBlock(String(block_hash), true);
            case 5:
              block = _context11.v;
              _context11.n = 7;
              break;
            case 6:
              _context11.p = 6;
              _t13 = _context11.v;
              console.warn('Store: could not load block to recover fulfillment spends', block_hash, _t13);
              return _context11.a(2, false);
            case 7:
              if (block) {
                _context11.n = 8;
                break;
              }
              console.warn('Store: block missing while recovering fulfillment spends', block_hash);
              return _context11.a(2, false);
            case 8:
              transactions = ((_block = block) === null || _block === void 0 ? void 0 : _block.transactions) || [];
              _iterator1 = _createForOfIteratorHelper(transactions);
              _context11.p = 9;
              _iterator1.s();
            case 10:
              if ((_step1 = _iterator1.n()).done) {
                _context11.n = 13;
                break;
              }
              tx = _step1.value;
              txmsg = this.returnTransactionMessage(tx);
              if (!(txmsg.module !== 'Store' || !txmsg.fulfill_sale)) {
                _context11.n = 11;
                break;
              }
              return _context11.a(3, 12);
            case 11:
              _context11.n = 12;
              return this.recordFulfillmentSpends(block, tx, {
                buyer: txmsg.fulfill_sale.buyer || '',
                note: '',
                quantity: Number(txmsg.fulfill_sale.quantity) || null
              });
            case 12:
              _context11.n = 10;
              break;
            case 13:
              _context11.n = 15;
              break;
            case 14:
              _context11.p = 14;
              _t14 = _context11.v;
              _iterator1.e(_t14);
            case 15:
              _context11.p = 15;
              _iterator1.f();
              return _context11.f(15);
            case 16:
              return _context11.a(2, true);
          }
        }, _callee11, this, [[9, 14, 15, 16], [4, 6]]);
      }));
      function recoverMissingFulfillmentSpends(_x12, _x13) {
        return _recoverMissingFulfillmentSpends.apply(this, arguments);
      }
      return recoverMissingFulfillmentSpends;
    }()
  }, {
    key: "processQueue",
    value: function () {
      var _processQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var _this$mod$order_retry;
        var orders, retry_limit, _iterator10, _step10, order_row, order, listing_rows, _t15;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2);
            case 1:
              _context12.n = 2;
              return this.resetStaleSettlementPendingListings();
            case 2:
              _context12.n = 3;
              return this.resetOrphanedSettlements();
            case 3:
              _context12.n = 4;
              return this.resetOrphanedFulfillments();
            case 4:
              _context12.n = 5;
              return this.db.returnPendingOrders();
            case 5:
              orders = _context12.v;
              if (orders !== null && orders !== void 0 && orders.length) {
                _context12.n = 6;
                break;
              }
              return _context12.a(2);
            case 6:
              retry_limit = Number((_this$mod$order_retry = this.mod.order_retry_limit) !== null && _this$mod$order_retry !== void 0 ? _this$mod$order_retry : 10);
              _iterator10 = _createForOfIteratorHelper(orders);
              _context12.p = 7;
              _iterator10.s();
            case 8:
              if ((_step10 = _iterator10.n()).done) {
                _context12.n = 16;
                break;
              }
              order_row = _step10.value;
              order = new Order(order_row);
              if (order.isProcessable()) {
                _context12.n = 10;
                break;
              }
              if (!order.isAwaitingSettlementConfirmation()) {
                _context12.n = 9;
                break;
              }
              return _context12.a(3, 15);
            case 9:
              return _context12.a(3, 15);
            case 10:
              _context12.n = 11;
              return this.getListingsForFulfillment(order_row);
            case 11:
              listing_rows = _context12.v;
              if (listing_rows.length) {
                _context12.n = 13;
                break;
              }
              _context12.n = 12;
              return this.deferOrder(order, retry_limit);
            case 12:
              return _context12.a(3, 15);
            case 13:
              _context12.n = 14;
              return this.fulfillOrder(order_row, listing_rows);
            case 14:
              if (!_context12.v) {
                _context12.n = 15;
                break;
              }
              return _context12.a(3, 16);
            case 15:
              _context12.n = 8;
              break;
            case 16:
              _context12.n = 18;
              break;
            case 17:
              _context12.p = 17;
              _t15 = _context12.v;
              _iterator10.e(_t15);
            case 18:
              _context12.p = 18;
              _iterator10.f();
              return _context12.f(18);
            case 19:
              return _context12.a(2);
          }
        }, _callee12, this, [[7, 17, 18, 19]]);
      }));
      function processQueue() {
        return _processQueue.apply(this, arguments);
      }
      return processQueue;
    }()
  }, {
    key: "resetOrphanedSettlements",
    value: function () {
      var _resetOrphanedSettlements = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var rows, now, _iterator11, _step11, row, order, _t16;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              _context13.n = 1;
              return this.db.returnOrphanedSettlingOrders();
            case 1:
              rows = _context13.v;
              now = Date.now();
              _iterator11 = _createForOfIteratorHelper(rows || []);
              _context13.p = 2;
              _iterator11.s();
            case 3:
              if ((_step11 = _iterator11.n()).done) {
                _context13.n = 7;
                break;
              }
              row = _step11.value;
              order = new Order(row);
              _context13.n = 4;
              return this.clearSettlementPendingForOrder(order);
            case 4:
              _context13.n = 5;
              return this.db.updateOrder(order.id, {
                settlement_tx_sig: '',
                status: ORDER_STATUS_PENDING,
                block_id_fulfilled: 0,
                block_hash_fulfilled: '',
                transaction_id_fulfilled: 0,
                longest_chain_fulfilled: 0
              });
            case 5:
              _context13.n = 6;
              return this.syncSummaryForBucket(order.nft_id, order.price);
            case 6:
              _context13.n = 3;
              break;
            case 7:
              _context13.n = 9;
              break;
            case 8:
              _context13.p = 8;
              _t16 = _context13.v;
              _iterator11.e(_t16);
            case 9:
              _context13.p = 9;
              _iterator11.f();
              return _context13.f(9);
            case 10:
              return _context13.a(2);
          }
        }, _callee13, this, [[2, 8, 9, 10]]);
      }));
      function resetOrphanedSettlements() {
        return _resetOrphanedSettlements.apply(this, arguments);
      }
      return resetOrphanedSettlements;
    }()
  }, {
    key: "resetStaleSettlementPendingListings",
    value: function () {
      var _resetStaleSettlementPendingListings = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var pending_rows, settling_orders, reserved, _iterator12, _step12, order_row, signatures, _iterator14, _step14, signature, now, _iterator13, _step13, row, _t17, _t18;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              _context14.n = 1;
              return this.db.returnListingsWithSettlementPending();
            case 1:
              pending_rows = _context14.v;
              if (pending_rows !== null && pending_rows !== void 0 && pending_rows.length) {
                _context14.n = 2;
                break;
              }
              return _context14.a(2);
            case 2:
              _context14.n = 3;
              return this.db.returnSettlingOrders();
            case 3:
              settling_orders = _context14.v;
              reserved = new Set();
              _iterator12 = _createForOfIteratorHelper(settling_orders || []);
              _context14.p = 4;
              _iterator12.s();
            case 5:
              if ((_step12 = _iterator12.n()).done) {
                _context14.n = 8;
                break;
              }
              order_row = _step12.value;
              _context14.n = 6;
              return this.returnSettlementListingSignatures(order_row);
            case 6:
              signatures = _context14.v;
              _iterator14 = _createForOfIteratorHelper(signatures);
              try {
                for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                  signature = _step14.value;
                  reserved.add(signature);
                }
              } catch (err) {
                _iterator14.e(err);
              } finally {
                _iterator14.f();
              }
            case 7:
              _context14.n = 5;
              break;
            case 8:
              _context14.n = 10;
              break;
            case 9:
              _context14.p = 9;
              _t17 = _context14.v;
              _iterator12.e(_t17);
            case 10:
              _context14.p = 10;
              _iterator12.f();
              return _context14.f(10);
            case 11:
              now = Date.now();
              _iterator13 = _createForOfIteratorHelper(pending_rows);
              _context14.p = 12;
              _iterator13.s();
            case 13:
              if ((_step13 = _iterator13.n()).done) {
                _context14.n = 17;
                break;
              }
              row = _step13.value;
              if (!reserved.has(row.signature)) {
                _context14.n = 14;
                break;
              }
              return _context14.a(3, 16);
            case 14:
              _context14.n = 15;
              return this.db.clearListingSettlementPending(row.signature, row.block_hash_listed, now);
            case 15:
              _context14.n = 16;
              return this.syncSummaryForBucket(row.nft_id, row.price);
            case 16:
              _context14.n = 13;
              break;
            case 17:
              _context14.n = 19;
              break;
            case 18:
              _context14.p = 18;
              _t18 = _context14.v;
              _iterator13.e(_t18);
            case 19:
              _context14.p = 19;
              _iterator13.f();
              return _context14.f(19);
            case 20:
              return _context14.a(2);
          }
        }, _callee14, this, [[12, 18, 19, 20], [4, 9, 10, 11]]);
      }));
      function resetStaleSettlementPendingListings() {
        return _resetStaleSettlementPendingListings.apply(this, arguments);
      }
      return resetStaleSettlementPendingListings;
    }()
  }, {
    key: "returnSettlementListingSignatures",
    value: function () {
      var _returnSettlementListingSignatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(order_row) {
        var _settlement_tx$return;
        var settlement_tx, txmsg, fulfill, signatures;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              if (order_row !== null && order_row !== void 0 && order_row.settlement_tx_sig) {
                _context15.n = 1;
                break;
              }
              return _context15.a(2, []);
            case 1:
              _context15.n = 2;
              return loadTransactionFromArchive(this.app, order_row.settlement_tx_sig);
            case 2:
              settlement_tx = _context15.v;
              txmsg = (settlement_tx === null || settlement_tx === void 0 || (_settlement_tx$return = settlement_tx.returnMessage) === null || _settlement_tx$return === void 0 ? void 0 : _settlement_tx$return.call(settlement_tx)) || {};
              fulfill = txmsg.fulfill_sale || {};
              signatures = Array.isArray(fulfill.listing_signatures) ? fulfill.listing_signatures.filter(Boolean) : [];
              if (!signatures.length && fulfill.prior_inventory) {
                signatures.push(fulfill.prior_inventory);
              }
              return _context15.a(2, signatures);
          }
        }, _callee15, this);
      }));
      function returnSettlementListingSignatures(_x14) {
        return _returnSettlementListingSignatures.apply(this, arguments);
      }
      return returnSettlementListingSignatures;
    }()
  }, {
    key: "clearSettlementPendingForOrder",
    value: function () {
      var _clearSettlementPendingForOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(order) {
        var signatures, now, _iterator15, _step15, signature, _i3, _Object$values3, listing, _t19;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              _context16.n = 1;
              return this.returnSettlementListingSignatures(order);
            case 1:
              signatures = _context16.v;
              now = Date.now();
              _iterator15 = _createForOfIteratorHelper(signatures);
              _context16.p = 2;
              _iterator15.s();
            case 3:
              if ((_step15 = _iterator15.n()).done) {
                _context16.n = 6;
                break;
              }
              signature = _step15.value;
              _context16.n = 4;
              return this.db.clearListingSettlementPending(signature, null, now);
            case 4:
              for (_i3 = 0, _Object$values3 = Object.values(this.listings); _i3 < _Object$values3.length; _i3++) {
                listing = _Object$values3[_i3];
                if (listing.signature === signature && listing.isSettlementPending()) {
                  listing.settlement_pending = 0;
                }
              }
            case 5:
              _context16.n = 3;
              break;
            case 6:
              _context16.n = 8;
              break;
            case 7:
              _context16.p = 7;
              _t19 = _context16.v;
              _iterator15.e(_t19);
            case 8:
              _context16.p = 8;
              _iterator15.f();
              return _context16.f(8);
            case 9:
              return _context16.a(2);
          }
        }, _callee16, this, [[2, 7, 8, 9]]);
      }));
      function clearSettlementPendingForOrder(_x15) {
        return _clearSettlementPendingForOrder.apply(this, arguments);
      }
      return clearSettlementPendingForOrder;
    }()
  }, {
    key: "resetOrphanedFulfillments",
    value: function () {
      var _resetOrphanedFulfillments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        var rows, _iterator16, _step16, row, order, _t20;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.p = _context17.n) {
            case 0:
              _context17.n = 1;
              return this.db.returnOrphanedFulfilledOrders();
            case 1:
              rows = _context17.v;
              _iterator16 = _createForOfIteratorHelper(rows || []);
              _context17.p = 2;
              _iterator16.s();
            case 3:
              if ((_step16 = _iterator16.n()).done) {
                _context17.n = 5;
                break;
              }
              row = _step16.value;
              order = new Order(row);
              _context17.n = 4;
              return this.db.updateOrder(order.id, {
                settlement_tx_sig: '',
                status: ORDER_STATUS_PENDING,
                block_id_fulfilled: 0,
                block_hash_fulfilled: '',
                transaction_id_fulfilled: 0,
                longest_chain_fulfilled: 0
              });
            case 4:
              _context17.n = 3;
              break;
            case 5:
              _context17.n = 7;
              break;
            case 6:
              _context17.p = 6;
              _t20 = _context17.v;
              _iterator16.e(_t20);
            case 7:
              _context17.p = 7;
              _iterator16.f();
              return _context17.f(7);
            case 8:
              return _context17.a(2);
          }
        }, _callee17, this, [[2, 6, 7, 8]]);
      }));
      function resetOrphanedFulfillments() {
        return _resetOrphanedFulfillments.apply(this, arguments);
      }
      return resetOrphanedFulfillments;
    }()
  }, {
    key: "deferOrder",
    value: function () {
      var _deferOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(order, retry_limit) {
        var attempts;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              _context18.n = 1;
              return this.db.incrementOrderAttempts(order.id);
            case 1:
              attempts = _context18.v;
              if (!(attempts >= retry_limit)) {
                _context18.n = 2;
                break;
              }
              _context18.n = 2;
              return this.failOrder(order);
            case 2:
              return _context18.a(2);
          }
        }, _callee18, this);
      }));
      function deferOrder(_x16, _x17) {
        return _deferOrder.apply(this, arguments);
      }
      return deferOrder;
    }()
  }, {
    key: "failOrder",
    value: function () {
      var _failOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(order) {
        var _t21;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.p = _context19.n) {
            case 0:
              _context19.n = 1;
              return this.db.updateOrder(order.id, {
                status: ORDER_STATUS_UNFULFILLABLE
              });
            case 1:
              _context19.p = 1;
              _context19.n = 2;
              return this.mod.propagateOrderRefund(order, {
                refund_public_key: order.buyer,
                reason: 'unable-to-fulfill'
              });
            case 2:
              _context19.n = 4;
              break;
            case 3:
              _context19.p = 3;
              _t21 = _context19.v;
              console.warn('Store: order refund failed', _t21 === null || _t21 === void 0 ? void 0 : _t21.message);
            case 4:
              return _context19.a(2);
          }
        }, _callee19, this, [[1, 3]]);
      }));
      function failOrder(_x18) {
        return _failOrder.apply(this, arguments);
      }
      return failOrder;
    }()
    /**
     * Single fulfillment planner: validates the order and selects listing rows, or returns [].
     */
  }, {
    key: "getListingsForFulfillment",
    value: function () {
      var _getListingsForFulfillment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(order_row) {
        var _order$price, _summary_row$quantity, _order$price2, _summary_row$price, _order$price3, _order$payment_amount;
        var order, quantity, max_price, summary_row, required_payment, bucket_price, candidates, remaining, listing_rows, _iterator17, _step17, listing_row, row_qty, take_qty, _t22;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.p = _context20.n) {
            case 0:
              order = new Order(order_row);
              quantity = Number(order.quantity) || 1;
              max_price = Number((_order$price = order.price) !== null && _order$price !== void 0 ? _order$price : 0);
              _context20.n = 1;
              return this.db.returnSummaryByBucket(order.nft_id, max_price);
            case 1:
              summary_row = _context20.v;
              if (summary_row) {
                _context20.n = 2;
                break;
              }
              return _context20.a(2, []);
            case 2:
              if (!(Number((_summary_row$quantity = summary_row.quantity_available) !== null && _summary_row$quantity !== void 0 ? _summary_row$quantity : 0) < quantity)) {
                _context20.n = 3;
                break;
              }
              return _context20.a(2, []);
            case 3:
              if (!(BigInt((_order$price2 = order.price) !== null && _order$price2 !== void 0 ? _order$price2 : 0) < BigInt((_summary_row$price = summary_row.price) !== null && _summary_row$price !== void 0 ? _summary_row$price : 0))) {
                _context20.n = 4;
                break;
              }
              return _context20.a(2, []);
            case 4:
              required_payment = BigInt((_order$price3 = order.price) !== null && _order$price3 !== void 0 ? _order$price3 : 0) * BigInt(quantity);
              if (!(BigInt((_order$payment_amount = order.payment_amount) !== null && _order$payment_amount !== void 0 ? _order$payment_amount : 0) < required_payment)) {
                _context20.n = 5;
                break;
              }
              return _context20.a(2, []);
            case 5:
              _context20.n = 6;
              return this.db.returnLowestSatisfyingPriceForNft(order.nft_id, max_price, quantity);
            case 6:
              bucket_price = _context20.v;
              if (!(bucket_price === null)) {
                _context20.n = 7;
                break;
              }
              return _context20.a(2, []);
            case 7:
              _context20.n = 8;
              return this.db.returnSpendableListingsForBucket(order.nft_id, bucket_price, quantity);
            case 8:
              candidates = _context20.v;
              if (candidates !== null && candidates !== void 0 && candidates.length) {
                _context20.n = 9;
                break;
              }
              return _context20.a(2, []);
            case 9:
              remaining = quantity;
              listing_rows = [];
              _iterator17 = _createForOfIteratorHelper(candidates);
              _context20.p = 10;
              _iterator17.s();
            case 11:
              if ((_step17 = _iterator17.n()).done) {
                _context20.n = 17;
                break;
              }
              listing_row = _step17.value;
              if (!(remaining <= 0)) {
                _context20.n = 12;
                break;
              }
              return _context20.a(3, 17);
            case 12:
              if (!(!listing_row.access_script || !listingInputSlipJsonFromRecord(listing_row))) {
                _context20.n = 13;
                break;
              }
              return _context20.a(2, []);
            case 13:
              _context20.n = 14;
              return executeListingScript(this.app, listing_row.access_script, this.mod.store_public_key);
            case 14:
              if (_context20.v) {
                _context20.n = 15;
                break;
              }
              return _context20.a(2, []);
            case 15:
              row_qty = Number(listing_row.quantity) || 1;
              take_qty = Math.min(row_qty, remaining);
              listing_rows.push(_objectSpread(_objectSpread({}, listing_row), {}, {
                take_qty: take_qty
              }));
              remaining -= take_qty;
            case 16:
              _context20.n = 11;
              break;
            case 17:
              _context20.n = 19;
              break;
            case 18:
              _context20.p = 18;
              _t22 = _context20.v;
              _iterator17.e(_t22);
            case 19:
              _context20.p = 19;
              _iterator17.f();
              return _context20.f(19);
            case 20:
              if (!(remaining > 0)) {
                _context20.n = 21;
                break;
              }
              return _context20.a(2, []);
            case 21:
              return _context20.a(2, listing_rows);
          }
        }, _callee20, this, [[10, 18, 19, 20]]);
      }));
      function getListingsForFulfillment(_x19) {
        return _getListingsForFulfillment.apply(this, arguments);
      }
      return getListingsForFulfillment;
    }()
  }, {
    key: "fulfillOrder",
    value: function () {
      var _fulfillOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(order_row, listing_rows) {
        var _listing_rows$2;
        var order, fulfillment_tx, listing_tx, _listing_rows$, _primary_signature, now, _iterator18, _step18, listing_row, key, primary_signature, _nft$returnImage, nft, nft_image, _t23, _t24, _t25;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.p = _context21.n) {
            case 0:
              order = new Order(order_row);
              fulfillment_tx = null;
              listing_tx = null;
              _context21.p = 1;
              _primary_signature = (_listing_rows$ = listing_rows[0]) === null || _listing_rows$ === void 0 ? void 0 : _listing_rows$.signature;
              if (!_primary_signature) {
                _context21.n = 3;
                break;
              }
              _context21.n = 2;
              return loadTransactionFromArchive(this.app, _primary_signature);
            case 2:
              _t23 = _context21.v;
              _context21.n = 4;
              break;
            case 3:
              _t23 = null;
            case 4:
              listing_tx = _t23;
              if (listing_tx) {
                _context21.n = 5;
                break;
              }
              throw new Error('listing transaction not available from archive');
            case 5:
              _context21.n = 6;
              return this.mod.createFulfillmentTransaction(order, listing_rows, listing_tx);
            case 6:
              fulfillment_tx = _context21.v;
              _context21.n = 8;
              break;
            case 7:
              _context21.p = 7;
              _t24 = _context21.v;
              console.warn('Store: fulfillOrder settlement build failed', _t24 === null || _t24 === void 0 ? void 0 : _t24.message);
              return _context21.a(2, false);
            case 8:
              now = Date.now();
              _iterator18 = _createForOfIteratorHelper(listing_rows);
              _context21.p = 9;
              _iterator18.s();
            case 10:
              if ((_step18 = _iterator18.n()).done) {
                _context21.n = 13;
                break;
              }
              listing_row = _step18.value;
              _context21.n = 11;
              return this.db.markListingSettlementPending(listing_row.signature, listing_row.block_hash_listed, now);
            case 11:
              key = this.listingCacheKey(listing_row.signature, listing_row.block_hash_listed);
              if (this.listings[key]) {
                this.listings[key].settlement_pending = 1;
              }
            case 12:
              _context21.n = 10;
              break;
            case 13:
              _context21.n = 15;
              break;
            case 14:
              _context21.p = 14;
              _t25 = _context21.v;
              _iterator18.e(_t25);
            case 15:
              _context21.p = 15;
              _iterator18.f();
              return _context21.f(15);
            case 16:
              _context21.n = 17;
              return this.syncSummaryForBucket(order.nft_id, order.price);
            case 17:
              primary_signature = (_listing_rows$2 = listing_rows[0]) === null || _listing_rows$2 === void 0 ? void 0 : _listing_rows$2.signature;
              if (primary_signature && order.nft_id && !this.mod.image_cache[order.nft_id] && listing_tx) {
                nft = new SaitoNFT(this.app, this.mod, listing_tx, null);
                nft_image = ((_nft$returnImage = nft.returnImage) === null || _nft$returnImage === void 0 ? void 0 : _nft$returnImage.call(nft)) || '';
                if (nft_image) {
                  this.mod.image_cache[order.nft_id] = nft_image;
                }
              }
              _context21.n = 18;
              return this.db.updateOrder(order.id, {
                settlement_tx_sig: fulfillment_tx.signature,
                status: ORDER_STATUS_SETTLING
              });
            case 18:
              console.log('Store: fulfillOrder propagating settlement', fulfillment_tx.signature);
              this.app.network.propagateTransaction(fulfillment_tx);
              return _context21.a(2, true);
          }
        }, _callee21, this, [[9, 14, 15, 16], [1, 7]]);
      }));
      function fulfillOrder(_x20, _x21) {
        return _fulfillOrder.apply(this, arguments);
      }
      return fulfillOrder;
    }() // --- summaries ---
    /**
     * Full summary rebuild — only for chain rollback recovery
     * (onChainReorganization with longest_chain === false).
     */
  }, {
    key: "rebuildSummaries",
    value: function () {
      var _rebuildSummaries2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22() {
        var _this3 = this;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              return _context22.a(2, this.withSummaryMutation(function () {
                return _this3._rebuildSummaries();
              }));
          }
        }, _callee22, this);
      }));
      function rebuildSummaries() {
        return _rebuildSummaries2.apply(this, arguments);
      }
      return rebuildSummaries;
    }()
  }, {
    key: "_rebuildSummaries",
    value: function () {
      var _rebuildSummaries3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
        var buckets, existing, existing_by_bucket, _iterator19, _step19, _row, now, planned, _iterator20, _step20, _bucket$price, _bucket$total_quantit, bucket, nft_id, price, prev, active_listing, _i4, _planned, _item$active_listing, _item$active_listing2, item, row, summary, key, _t26;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.p = _context23.n) {
            case 0:
              _context23.n = 1;
              return this.db.scanListingsForSummaryRebuild();
            case 1:
              buckets = _context23.v;
              _context23.n = 2;
              return this.db.loadAllSummaries();
            case 2:
              existing = _context23.v;
              existing_by_bucket = {};
              _iterator19 = _createForOfIteratorHelper(existing || []);
              try {
                for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                  _row = _step19.value;
                  existing_by_bucket[summaryBucketKey(_row.nft_id, _row.price)] = _row;
                }
              } catch (err) {
                _iterator19.e(err);
              } finally {
                _iterator19.f();
              }
              now = Date.now();
              planned = [];
              _iterator20 = _createForOfIteratorHelper(buckets || []);
              _context23.p = 3;
              _iterator20.s();
            case 4:
              if ((_step20 = _iterator20.n()).done) {
                _context23.n = 7;
                break;
              }
              bucket = _step20.value;
              nft_id = bucket.nft_id;
              price = Number((_bucket$price = bucket.price) !== null && _bucket$price !== void 0 ? _bucket$price : 0);
              prev = existing_by_bucket[summaryBucketKey(nft_id, price)] || {};
              _context23.n = 5;
              return this.db.returnActiveListingForBucket(nft_id, price);
            case 5:
              active_listing = _context23.v;
              planned.push({
                nft_id: nft_id,
                price: price,
                category: prev.category || (active_listing === null || active_listing === void 0 ? void 0 : active_listing.category) || STORE_CATEGORIES.OTHER,
                title: prev.title || '',
                description: prev.description || '',
                image: null,
                quantity_available: Number((_bucket$total_quantit = bucket.total_quantity) !== null && _bucket$total_quantit !== void 0 ? _bucket$total_quantit : 0),
                updated_at: now,
                active_listing: active_listing
              });
            case 6:
              _context23.n = 4;
              break;
            case 7:
              _context23.n = 9;
              break;
            case 8:
              _context23.p = 8;
              _t26 = _context23.v;
              _iterator20.e(_t26);
            case 9:
              _context23.p = 9;
              _iterator20.f();
              return _context23.f(9);
            case 10:
              _context23.n = 11;
              return this.db.replaceAllSummaries(planned.map(function (_ref4) {
                var active_listing = _ref4.active_listing,
                  row = _objectWithoutProperties(_ref4, _excluded);
                return row;
              }));
            case 11:
              this.summaries = {};
              _i4 = 0, _planned = planned;
            case 12:
              if (!(_i4 < _planned.length)) {
                _context23.n = 16;
                break;
              }
              item = _planned[_i4];
              _context23.n = 13;
              return this.db.returnSummaryByBucket(item.nft_id, item.price);
            case 13:
              row = _context23.v;
              if (row) {
                _context23.n = 14;
                break;
              }
              return _context23.a(3, 15);
            case 14:
              summary = new Summary(this.app, this.mod, row);
              if ((_item$active_listing = item.active_listing) !== null && _item$active_listing !== void 0 && _item$active_listing.signature) {
                summary.listing_signature = item.active_listing.signature;
              }
              if ((_item$active_listing2 = item.active_listing) !== null && _item$active_listing2 !== void 0 && _item$active_listing2.category) {
                summary.category = item.active_listing.category;
              }
              key = summaryBucketKey(item.nft_id, item.price);
              this.summaries[key] = summary;
              syncSummaryCache(this.mod, summary);
            case 15:
              _i4++;
              _context23.n = 12;
              break;
            case 16:
              this.mod.summaries = this.summaries;
            case 17:
              return _context23.a(2);
          }
        }, _callee23, this, [[3, 8, 9, 10]]);
      }));
      function _rebuildSummaries() {
        return _rebuildSummaries3.apply(this, arguments);
      }
      return _rebuildSummaries;
    }()
  }, {
    key: "returnActiveSummaries",
    value: function returnActiveSummaries() {
      return Object.values(this.summaries).filter(function (summary) {
        return summary.isActive();
      });
    }

    /**
     * Seller Admin / public storefront inventory from warehouse listings.
     * Returns Summary-compatible objects ready for Teaser rendering.
     */
  }, {
    key: "returnSellerInventory",
    value: function () {
      var _returnSellerInventory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24() {
        var seller,
          key,
          active_rows,
          sold_rows,
          active,
          _iterator21,
          _step21,
          row,
          summary,
          sold,
          _iterator22,
          _step22,
          _row2,
          _summary,
          _args24 = arguments,
          _t27,
          _t28;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.p = _context24.n) {
            case 0:
              seller = _args24.length > 0 && _args24[0] !== undefined ? _args24[0] : '';
              key = String(seller || '').trim();
              if (!(!key || this.app.BROWSER)) {
                _context24.n = 1;
                break;
              }
              return _context24.a(2, {
                seller: key,
                active: [],
                sold: []
              });
            case 1:
              _context24.n = 2;
              return this.db.returnActiveListingsForSeller(key);
            case 2:
              active_rows = _context24.v;
              _context24.n = 3;
              return this.db.returnSoldListingsForSeller(key);
            case 3:
              sold_rows = _context24.v;
              active = [];
              _iterator21 = _createForOfIteratorHelper(active_rows || []);
              _context24.p = 4;
              _iterator21.s();
            case 5:
              if ((_step21 = _iterator21.n()).done) {
                _context24.n = 8;
                break;
              }
              row = _step21.value;
              _context24.n = 6;
              return this.summaryFromListingRow(row, {
                sold: false
              });
            case 6:
              summary = _context24.v;
              if (summary) {
                active.push(summary);
              }
            case 7:
              _context24.n = 5;
              break;
            case 8:
              _context24.n = 10;
              break;
            case 9:
              _context24.p = 9;
              _t27 = _context24.v;
              _iterator21.e(_t27);
            case 10:
              _context24.p = 10;
              _iterator21.f();
              return _context24.f(10);
            case 11:
              sold = [];
              _iterator22 = _createForOfIteratorHelper(sold_rows || []);
              _context24.p = 12;
              _iterator22.s();
            case 13:
              if ((_step22 = _iterator22.n()).done) {
                _context24.n = 16;
                break;
              }
              _row2 = _step22.value;
              _context24.n = 14;
              return this.summaryFromListingRow(_row2, {
                sold: true
              });
            case 14:
              _summary = _context24.v;
              if (_summary) {
                sold.push(_summary);
              }
            case 15:
              _context24.n = 13;
              break;
            case 16:
              _context24.n = 18;
              break;
            case 17:
              _context24.p = 17;
              _t28 = _context24.v;
              _iterator22.e(_t28);
            case 18:
              _context24.p = 18;
              _iterator22.f();
              return _context24.f(18);
            case 19:
              return _context24.a(2, {
                seller: key,
                active: active,
                sold: sold
              });
          }
        }, _callee24, this, [[12, 17, 18, 19], [4, 9, 10, 11]]);
      }));
      function returnSellerInventory() {
        return _returnSellerInventory.apply(this, arguments);
      }
      return returnSellerInventory;
    }()
  }, {
    key: "summaryFromListingRow",
    value: function () {
      var _summaryFromListingRow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(row) {
        var _row$price, _row$quantity4, _this$mod$image_cache, _meta$description, _row$approved, _row$quantity_sold, _row$quantity5;
        var _ref5,
          _ref5$sold,
          sold,
          price,
          qty,
          meta,
          image,
          _args25 = arguments,
          _t29;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              _ref5 = _args25.length > 1 && _args25[1] !== undefined ? _args25[1] : {}, _ref5$sold = _ref5.sold, sold = _ref5$sold === void 0 ? false : _ref5$sold;
              if (row !== null && row !== void 0 && row.nft_id) {
                _context25.n = 1;
                break;
              }
              return _context25.a(2, null);
            case 1:
              price = Number((_row$price = row.price) !== null && _row$price !== void 0 ? _row$price : 0);
              qty = Math.max(0, Number((_row$quantity4 = row.quantity) !== null && _row$quantity4 !== void 0 ? _row$quantity4 : 0) || 0);
              _context25.n = 2;
              return this.db.returnSummaryByBucket(row.nft_id, price);
            case 2:
              _t29 = _context25.v;
              if (_t29) {
                _context25.n = 3;
                break;
              }
              _t29 = {};
            case 3:
              meta = _t29;
              image = meta.image || row.nft_id && ((_this$mod$image_cache = this.mod.image_cache) === null || _this$mod$image_cache === void 0 ? void 0 : _this$mod$image_cache[row.nft_id]) || null;
              return _context25.a(2, new Summary(this.app, this.mod, {
                nft_id: row.nft_id,
                seller: row.seller || '',
                category: row.category || meta.category || STORE_CATEGORIES.OTHER,
                title: String(meta.title || '').trim(),
                description: String((_meta$description = meta.description) !== null && _meta$description !== void 0 ? _meta$description : '').trim(),
                image: image,
                price: price,
                web3_ticker: row.web3_ticker || meta.web3_ticker || '',
                web3_amount: row.web3_amount || meta.web3_amount || '',
                quantity_available: sold ? 0 : qty,
                quantity_total: qty,
                listing_signature: row.signature || '',
                approved: Number((_row$approved = row.approved) !== null && _row$approved !== void 0 ? _row$approved : 0),
                risk: row.risk === 'Low' || row.risk === 'Medium' || row.risk === 'High' || row.risk === 'Dangerous' ? row.risk : '',
                created_at: Number(row.created_at || 0),
                updated_at: Number(row.updated_at || row.created_at || meta.updated_at || 0),
                status: sold ? 0 : 1,
                note: sold ? String(row.note || '') : '',
                buyer: sold ? String(row.buyer || '') : '',
                quantity_sold: sold ? Math.max(0, Number((_row$quantity_sold = row.quantity_sold) !== null && _row$quantity_sold !== void 0 ? _row$quantity_sold : 0) || Number((_row$quantity5 = row.quantity) !== null && _row$quantity5 !== void 0 ? _row$quantity5 : 0) || 0) : 0,
                // Prefer sold_at; for pre-migration sold rows, updated_at was set at settlement.
                sold_at: sold ? Number(row.sold_at || 0) || Number(row.updated_at || 0) || 0 : 0
              }));
          }
        }, _callee25, this);
      }));
      function summaryFromListingRow(_x22) {
        return _summaryFromListingRow.apply(this, arguments);
      }
      return summaryFromListingRow;
    }()
    /**
     * Listing rows filtered by seller set, category, and active/sold status, then paged.
     * sellers: public keys to include (single seller or ModTools whitelist). Empty → no results.
     * category '' / omitted = all categories.
     * status 'sold' → completed sales; anything else → active (marketplace default).
     * Single-seller queries use SQL COUNT/LIMIT/OFFSET. Whitelist (multi-seller) stays in-memory.
     */
  }, {
    key: "returnActiveListingsPage",
    value: function () {
      var _returnActiveListingsPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26() {
        var _ref6,
          _ref6$sellers,
          sellers,
          _ref6$category,
          category,
          _ref6$offset,
          offset,
          _ref6$page_size,
          page_size,
          _ref6$status,
          status,
          size,
          start,
          filter,
          listing_status,
          seller_keys,
          sold,
          empty,
          rows,
          total,
          allowed,
          listings,
          _iterator23,
          _step23,
          row,
          summary,
          page,
          _args26 = arguments,
          _t30,
          _t31,
          _t32,
          _t33;
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.p = _context26.n) {
            case 0:
              _ref6 = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : {}, _ref6$sellers = _ref6.sellers, sellers = _ref6$sellers === void 0 ? [] : _ref6$sellers, _ref6$category = _ref6.category, category = _ref6$category === void 0 ? '' : _ref6$category, _ref6$offset = _ref6.offset, offset = _ref6$offset === void 0 ? 0 : _ref6$offset, _ref6$page_size = _ref6.page_size, page_size = _ref6$page_size === void 0 ? 24 : _ref6$page_size, _ref6$status = _ref6.status, status = _ref6$status === void 0 ? 'active' : _ref6$status;
              size = normalizePageSize(page_size);
              start = normalizeOffset(offset);
              filter = String(category || '').trim();
              listing_status = String(status || '').toLowerCase() === 'sold' ? 'sold' : 'active';
              seller_keys = (Array.isArray(sellers) ? sellers : []).map(function (key) {
                return String(key || '').trim();
              }).filter(Boolean);
              sold = listing_status === 'sold';
              empty = {
                listings: [],
                category: filter,
                pagination: {
                  offset: 0,
                  page: 1,
                  page_size: size,
                  total: 0,
                  total_pages: 0,
                  has_next: false,
                  has_previous: false
                }
              };
              if (!(filter && !isStoreCategory(filter))) {
                _context26.n = 1;
                break;
              }
              return _context26.a(2, empty);
            case 1:
              rows = [];
              total = 0;
              if (!(seller_keys.length === 1)) {
                _context26.n = 7;
                break;
              }
              _context26.n = 2;
              return this.db.countListingsForSeller({
                seller: seller_keys[0],
                status: listing_status,
                category: filter
              });
            case 2:
              total = _context26.v;
              if (total > 0 && start >= total) {
                start = Math.floor((total - 1) / size) * size;
              }
              if (!(total > 0)) {
                _context26.n = 5;
                break;
              }
              _context26.n = 3;
              return this.db.returnListingsPageForSeller({
                seller: seller_keys[0],
                status: listing_status,
                category: filter,
                offset: start,
                page_size: size
              });
            case 3:
              _t31 = _context26.v;
              if (_t31) {
                _context26.n = 4;
                break;
              }
              _t31 = [];
            case 4:
              _t30 = _t31;
              _context26.n = 6;
              break;
            case 5:
              _t30 = [];
            case 6:
              rows = _t30;
              _context26.n = 10;
              break;
            case 7:
              if (!(listing_status === 'active' && seller_keys.length > 1)) {
                _context26.n = 10;
                break;
              }
              allowed = new Set(seller_keys);
              _context26.n = 8;
              return this.db.returnAllActiveListingRows();
            case 8:
              _t32 = _context26.v;
              if (_t32) {
                _context26.n = 9;
                break;
              }
              _t32 = [];
            case 9:
              rows = _t32.filter(function (row) {
                return allowed.has(String(row.seller || '').trim());
              });
              if (filter) {
                rows = rows.filter(function (row) {
                  return String(row.category || '') === filter;
                });
              }
              // Marketplace whitelist path: keep existing newest-first sort.
              rows.sort(function (a, b) {
                var td = Number(b.updated_at || b.created_at || 0) - Number(a.updated_at || a.created_at || 0);
                if (td !== 0) {
                  return td;
                }
                return String(a.signature || '').localeCompare(String(b.signature || ''));
              });
              total = rows.length;
              if (total > 0 && start >= total) {
                start = Math.floor((total - 1) / size) * size;
              }
              rows = rows.slice(start, start + size);
            case 10:
              listings = [];
              _iterator23 = _createForOfIteratorHelper(rows);
              _context26.p = 11;
              _iterator23.s();
            case 12:
              if ((_step23 = _iterator23.n()).done) {
                _context26.n = 15;
                break;
              }
              row = _step23.value;
              _context26.n = 13;
              return this.summaryFromListingRow(row, {
                sold: sold
              });
            case 13:
              summary = _context26.v;
              if (summary) {
                listings.push(summary);
              }
            case 14:
              _context26.n = 12;
              break;
            case 15:
              _context26.n = 17;
              break;
            case 16:
              _context26.p = 16;
              _t33 = _context26.v;
              _iterator23.e(_t33);
            case 17:
              _context26.p = 17;
              _iterator23.f();
              return _context26.f(17);
            case 18:
              page = size > 0 ? Math.floor(start / size) + 1 : 1;
              return _context26.a(2, {
                listings: listings,
                category: filter,
                pagination: {
                  offset: start,
                  page: page,
                  page_size: size,
                  total: total,
                  total_pages: total === 0 ? 0 : Math.ceil(total / size),
                  has_next: start + size < total,
                  has_previous: start > 0 && total > 0
                }
              });
          }
        }, _callee26, this, [[11, 16, 17, 18]]);
      }));
      function returnActiveListingsPage() {
        return _returnActiveListingsPage.apply(this, arguments);
      }
      return returnActiveListingsPage;
    }()
    /**
     * Main Store catalog: active listings whose seller is ModTools-whitelisted
     * OR whose listings.approved flag is 1. Independent of seller-scoped pages.
     * Empty whitelist still returns independently approved listings.
     */
  }, {
    key: "returnMarketplaceListingsPage",
    value: function () {
      var _returnMarketplaceListingsPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27() {
        var _ref7,
          _ref7$whitelist_selle,
          whitelist_sellers,
          _ref7$category,
          category,
          _ref7$offset,
          offset,
          _ref7$page_size,
          page_size,
          size,
          start,
          filter,
          empty,
          keys,
          total,
          rows,
          listings,
          _iterator24,
          _step24,
          row,
          summary,
          page,
          _args27 = arguments,
          _t34,
          _t35,
          _t36;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.p = _context27.n) {
            case 0:
              _ref7 = _args27.length > 0 && _args27[0] !== undefined ? _args27[0] : {}, _ref7$whitelist_selle = _ref7.whitelist_sellers, whitelist_sellers = _ref7$whitelist_selle === void 0 ? [] : _ref7$whitelist_selle, _ref7$category = _ref7.category, category = _ref7$category === void 0 ? '' : _ref7$category, _ref7$offset = _ref7.offset, offset = _ref7$offset === void 0 ? 0 : _ref7$offset, _ref7$page_size = _ref7.page_size, page_size = _ref7$page_size === void 0 ? 24 : _ref7$page_size;
              size = normalizePageSize(page_size);
              start = normalizeOffset(offset);
              filter = String(category || '').trim();
              empty = {
                listings: [],
                category: filter,
                pagination: {
                  offset: 0,
                  page: 1,
                  page_size: size,
                  total: 0,
                  total_pages: 0,
                  has_next: false,
                  has_previous: false
                }
              };
              if (!(filter && !isStoreCategory(filter))) {
                _context27.n = 1;
                break;
              }
              return _context27.a(2, empty);
            case 1:
              keys = (Array.isArray(whitelist_sellers) ? whitelist_sellers : []).map(function (key) {
                return String(key || '').trim();
              }).filter(Boolean);
              _context27.n = 2;
              return this.db.countMarketplaceListings({
                whitelist_sellers: keys,
                category: filter
              });
            case 2:
              total = _context27.v;
              if (total > 0 && start >= total) {
                start = Math.floor((total - 1) / size) * size;
              }
              if (!(total > 0)) {
                _context27.n = 5;
                break;
              }
              _context27.n = 3;
              return this.db.returnMarketplaceListingsPage({
                whitelist_sellers: keys,
                category: filter,
                offset: start,
                page_size: size
              });
            case 3:
              _t35 = _context27.v;
              if (_t35) {
                _context27.n = 4;
                break;
              }
              _t35 = [];
            case 4:
              _t34 = _t35;
              _context27.n = 6;
              break;
            case 5:
              _t34 = [];
            case 6:
              rows = _t34;
              listings = [];
              _iterator24 = _createForOfIteratorHelper(rows);
              _context27.p = 7;
              _iterator24.s();
            case 8:
              if ((_step24 = _iterator24.n()).done) {
                _context27.n = 11;
                break;
              }
              row = _step24.value;
              _context27.n = 9;
              return this.summaryFromListingRow(row, {
                sold: false
              });
            case 9:
              summary = _context27.v;
              if (summary) {
                listings.push(summary);
              }
            case 10:
              _context27.n = 8;
              break;
            case 11:
              _context27.n = 13;
              break;
            case 12:
              _context27.p = 12;
              _t36 = _context27.v;
              _iterator24.e(_t36);
            case 13:
              _context27.p = 13;
              _iterator24.f();
              return _context27.f(13);
            case 14:
              page = size > 0 ? Math.floor(start / size) + 1 : 1;
              return _context27.a(2, {
                listings: listings,
                category: filter,
                pagination: {
                  offset: start,
                  page: page,
                  page_size: size,
                  total: total,
                  total_pages: total === 0 ? 0 : Math.ceil(total / size),
                  has_next: start + size < total,
                  has_previous: start > 0 && total > 0
                }
              });
          }
        }, _callee27, this, [[7, 12, 13, 14]]);
      }));
      function returnMarketplaceListingsPage() {
        return _returnMarketplaceListingsPage.apply(this, arguments);
      }
      return returnMarketplaceListingsPage;
    }()
  }, {
    key: "returnPendingModerationPage",
    value: function () {
      var _returnPendingModerationPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28() {
        var _ref8,
          _ref8$offset,
          offset,
          _ref8$page_size,
          page_size,
          _ref8$sort,
          sort,
          _ref8$direction,
          direction,
          size,
          start,
          empty,
          total,
          rows,
          listings,
          _iterator25,
          _step25,
          row,
          summary,
          page,
          _args28 = arguments,
          _t37,
          _t38,
          _t39;
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.p = _context28.n) {
            case 0:
              _ref8 = _args28.length > 0 && _args28[0] !== undefined ? _args28[0] : {}, _ref8$offset = _ref8.offset, offset = _ref8$offset === void 0 ? 0 : _ref8$offset, _ref8$page_size = _ref8.page_size, page_size = _ref8$page_size === void 0 ? 24 : _ref8$page_size, _ref8$sort = _ref8.sort, sort = _ref8$sort === void 0 ? 'created_at' : _ref8$sort, _ref8$direction = _ref8.direction, direction = _ref8$direction === void 0 ? 'desc' : _ref8$direction;
              size = normalizePageSize(page_size);
              start = normalizeOffset(offset);
              empty = {
                listings: [],
                sort: String(sort || 'created_at'),
                direction: String(direction || '').toLowerCase() === 'asc' ? 'asc' : 'desc',
                pagination: {
                  offset: 0,
                  page: 1,
                  page_size: size,
                  total: 0,
                  total_pages: 0,
                  has_next: false,
                  has_previous: false
                }
              };
              if (!this.app.BROWSER) {
                _context28.n = 1;
                break;
              }
              return _context28.a(2, empty);
            case 1:
              _context28.n = 2;
              return this.db.countPendingModerationListings();
            case 2:
              total = _context28.v;
              if (total > 0 && start >= total) {
                start = Math.floor((total - 1) / size) * size;
              }
              if (!(total > 0)) {
                _context28.n = 5;
                break;
              }
              _context28.n = 3;
              return this.db.returnPendingModerationPage({
                offset: start,
                page_size: size,
                sort: sort,
                direction: direction
              });
            case 3:
              _t38 = _context28.v;
              if (_t38) {
                _context28.n = 4;
                break;
              }
              _t38 = [];
            case 4:
              _t37 = _t38;
              _context28.n = 6;
              break;
            case 5:
              _t37 = [];
            case 6:
              rows = _t37;
              listings = [];
              _iterator25 = _createForOfIteratorHelper(rows);
              _context28.p = 7;
              _iterator25.s();
            case 8:
              if ((_step25 = _iterator25.n()).done) {
                _context28.n = 11;
                break;
              }
              row = _step25.value;
              _context28.n = 9;
              return this.summaryFromListingRow(row, {
                sold: false
              });
            case 9:
              summary = _context28.v;
              if (summary) {
                listings.push(summary);
              }
            case 10:
              _context28.n = 8;
              break;
            case 11:
              _context28.n = 13;
              break;
            case 12:
              _context28.p = 12;
              _t39 = _context28.v;
              _iterator25.e(_t39);
            case 13:
              _context28.p = 13;
              _iterator25.f();
              return _context28.f(13);
            case 14:
              page = size > 0 ? Math.floor(start / size) + 1 : 1;
              return _context28.a(2, {
                listings: listings,
                sort: String(sort || 'created_at'),
                direction: String(direction || '').toLowerCase() === 'asc' ? 'asc' : 'desc',
                pagination: {
                  offset: start,
                  page: page,
                  page_size: size,
                  total: total,
                  total_pages: total === 0 ? 0 : Math.ceil(total / size),
                  has_next: start + size < total,
                  has_previous: start > 0 && total > 0
                }
              });
          }
        }, _callee28, this, [[7, 12, 13, 14]]);
      }));
      function returnPendingModerationPage() {
        return _returnPendingModerationPage.apply(this, arguments);
      }
      return returnPendingModerationPage;
    }()
  }, {
    key: "returnSummaryByBucket",
    value: function () {
      var _returnSummaryByBucket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(nft_id, price) {
        var key, row, summary, _t40;
        return _regenerator().w(function (_context29) {
          while (1) switch (_context29.p = _context29.n) {
            case 0:
              key = summaryBucketKey(nft_id, price);
              if (!this.summaries[key]) {
                _context29.n = 1;
                break;
              }
              return _context29.a(2, this.summaries[key]);
            case 1:
              _context29.p = 1;
              _context29.n = 2;
              return this.db.returnSummaryByBucket(nft_id, price);
            case 2:
              row = _context29.v;
              if (row) {
                _context29.n = 3;
                break;
              }
              return _context29.a(2, null);
            case 3:
              summary = new Summary(this.app, this.mod, row);
              this.summaries[key] = summary;
              syncSummaryCache(this.mod, summary);
              return _context29.a(2, summary);
            case 4:
              _context29.p = 4;
              _t40 = _context29.v;
              return _context29.a(2, null);
          }
        }, _callee29, this, [[1, 4]]);
      }));
      function returnSummaryByBucket(_x23, _x24) {
        return _returnSummaryByBucket.apply(this, arguments);
      }
      return returnSummaryByBucket;
    }() // --- internal ---
  }, {
    key: "addListingFromTransaction",
    value: function () {
      var _addListingFromTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(nft, tx, txmsg) {
        var _nft$returnImage2;
        var blk,
          signature,
          block_hash,
          _blk$id5,
          access_script,
          observation,
          risk,
          prior_inclusion,
          _prior_inclusion$appr,
          prior_decision,
          listing,
          image,
          _args30 = arguments;
        return _regenerator().w(function (_context30) {
          while (1) switch (_context30.n) {
            case 0:
              blk = _args30.length > 3 && _args30[3] !== undefined ? _args30[3] : null;
              signature = (tx === null || tx === void 0 ? void 0 : tx.signature) || '';
              if (tx !== null && tx !== void 0 && tx.signature) {
                _context30.n = 1;
                break;
              }
              console.warn('Store: addListingFromTransaction: malformed transaction (missing signature)');
              return _context30.a(2, null);
            case 1:
              // The block hash is half of a listing's identity: without it a second inclusion
              // of the same transaction could not be told apart from the first.
              block_hash = String((blk === null || blk === void 0 ? void 0 : blk.hash) || '');
              if (block_hash) {
                _context30.n = 2;
                break;
              }
              console.warn('Store: addListingFromTransaction: confirmation without a block hash', signature);
              return _context30.a(2, null);
            case 2:
              _context30.n = 3;
              return this.listingExists(tx.signature, block_hash);
            case 3:
              if (!_context30.v) {
                _context30.n = 5;
                break;
              }
              _context30.n = 4;
              return this.db.revealListingsInBlock(Number((_blk$id5 = blk === null || blk === void 0 ? void 0 : blk.id) !== null && _blk$id5 !== void 0 ? _blk$id5 : 0), block_hash);
            case 4:
              return _context30.a(2, null);
            case 5:
              access_script = txmsg.access_script || '';
              _context30.n = 6;
              return executeListingScript(this.app, access_script, this.mod.store_public_key);
            case 6:
              if (_context30.v) {
                _context30.n = 7;
                break;
              }
              console.warn('Store: addListingFromTransaction: executeListingScript failed', signature);
              return _context30.a(2, null);
            case 7:
              observation = this.observeListingFromTransaction(nft, tx, txmsg, blk);
              if (observation) {
                _context30.n = 8;
                break;
              }
              return _context30.a(2, null);
            case 8:
              // Server classifies the listing payload. Seller/browser-supplied risk is ignored.
              risk = '';
              try {
                risk = checkSecurityLevel(tx);
              } catch (err) {
                console.warn('Store: checkSecurityLevel failed', signature, (err === null || err === void 0 ? void 0 : err.message) || err);
                risk = '';
              }
              if (risk !== 'Low' && risk !== 'Medium' && risk !== 'High' && risk !== 'Dangerous') {
                risk = '';
              }
              observation.risk = risk;

              // A new inclusion is the same transaction in a different block: carry the
              // moderation decision over instead of sending it back through review.
              _context30.n = 9;
              return this.db.returnLatestListingInclusion(tx.signature);
            case 9:
              prior_inclusion = _context30.v;
              if (!prior_inclusion) {
                _context30.n = 10;
                break;
              }
              observation.approved = Number((_prior_inclusion$appr = prior_inclusion.approved) !== null && _prior_inclusion$appr !== void 0 ? _prior_inclusion$appr : 0) || 0;
              _context30.n = 12;
              break;
            case 10:
              if (!(observation.nft_id && observation.seller && Number(observation.quantity) > 0)) {
                _context30.n = 12;
                break;
              }
              _context30.n = 11;
              return this.db.returnLatestNftModeration(observation.nft_id, observation.seller);
            case 11:
              prior_decision = _context30.v;
              if (prior_decision) {
                observation.approved = prior_decision;
              }
            case 12:
              _context30.n = 13;
              return this.addListing(observation);
            case 13:
              listing = _context30.v;
              if (listing) {
                _context30.n = 14;
                break;
              }
              return _context30.a(2, null);
            case 14:
              // Archive early so restart recovery can rebuild metadata/image from the listing tx.
              this.app.storage.saveTransaction(tx, {
                field1: 'Store',
                preserve: 1
              }, 'localhost', blk)["catch"](function (err) {
                console.warn('Store: failed to save listing transaction to Archive', tx.signature, (err === null || err === void 0 ? void 0 : err.message) || err);
              });

              // Persist/update the nft_id+price summary from listing + txmsg (no placeholder row).
              _context30.n = 15;
              return this.applyListingToSummary(listing, txmsg);
            case 15:
              image = ((_nft$returnImage2 = nft.returnImage) === null || _nft$returnImage2 === void 0 ? void 0 : _nft$returnImage2.call(nft)) || '';
              if (image && listing.nft_id) {
                this.mod.image_cache[listing.nft_id] = image;
              }
              return _context30.a(2, listing);
          }
        }, _callee30, this);
      }));
      function addListingFromTransaction(_x25, _x26, _x27) {
        return _addListingFromTransaction.apply(this, arguments);
      }
      return addListingFromTransaction;
    }()
    /**
     * Write/update the market summary for a newly inserted listing using in-memory
     * listing + txmsg. Quantity is the aggregate of all active listings in the bucket.
     */
  }, {
    key: "applyListingToSummary",
    value: function () {
      var _applyListingToSummary2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(listing) {
        var _this4 = this;
        var txmsg,
          _args31 = arguments;
        return _regenerator().w(function (_context31) {
          while (1) switch (_context31.n) {
            case 0:
              txmsg = _args31.length > 1 && _args31[1] !== undefined ? _args31[1] : {};
              return _context31.a(2, this.withSummaryMutation(function () {
                return _this4._applyListingToSummary(listing, txmsg);
              }));
          }
        }, _callee31, this);
      }));
      function applyListingToSummary(_x28) {
        return _applyListingToSummary2.apply(this, arguments);
      }
      return applyListingToSummary;
    }()
  }, {
    key: "_applyListingToSummary",
    value: function () {
      var _applyListingToSummary3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(listing) {
        var _listing$price;
        var txmsg,
          nft_id,
          price,
          available,
          _this$extractListingM,
          title,
          description,
          category,
          now,
          existing,
          summary,
          key,
          _args32 = arguments;
        return _regenerator().w(function (_context32) {
          while (1) switch (_context32.n) {
            case 0:
              txmsg = _args32.length > 1 && _args32[1] !== undefined ? _args32[1] : {};
              if (listing !== null && listing !== void 0 && listing.nft_id) {
                _context32.n = 1;
                break;
              }
              throw new Error('Store: applyListingToSummary requires listing.nft_id');
            case 1:
              nft_id = listing.nft_id;
              price = Number((_listing$price = listing.price) !== null && _listing$price !== void 0 ? _listing$price : 0);
              _context32.n = 2;
              return this.db.sumListingQuantityForBucket(nft_id, price);
            case 2:
              available = _context32.v;
              _this$extractListingM = this.extractListingMetadata(txmsg), title = _this$extractListingM.title, description = _this$extractListingM.description;
              category = listing.category || STORE_CATEGORIES.OTHER;
              now = Date.now();
              _context32.n = 3;
              return this.db.returnSummaryByBucket(nft_id, price);
            case 3:
              existing = _context32.v;
              if (existing) {
                _context32.n = 5;
                break;
              }
              _context32.n = 4;
              return this.db.insertSummary({
                nft_id: nft_id,
                price: price,
                category: category,
                title: title,
                description: description,
                image: null,
                quantity_available: available,
                updated_at: now
              });
            case 4:
              _context32.n = 8;
              break;
            case 5:
              _context32.n = 6;
              return this.db.updateSummaryAvailableByBucket(nft_id, price, available, now);
            case 6:
              if (!(title || description)) {
                _context32.n = 7;
                break;
              }
              _context32.n = 7;
              return this.db.updateSummaryMetadata(nft_id, price, {
                title: title,
                description: description
              });
            case 7:
              if (!category) {
                _context32.n = 8;
                break;
              }
              _context32.n = 8;
              return this.db.updateSummaryCategory(nft_id, price, category);
            case 8:
              _context32.n = 9;
              return this.db.updateSummaryWeb3(nft_id, price, {
                web3_ticker: listing.web3_ticker || '',
                web3_amount: listing.web3_amount || ''
              });
            case 9:
              summary = new Summary(this.app, this.mod, {
                nft_id: nft_id,
                seller: listing.seller || (existing === null || existing === void 0 ? void 0 : existing.seller) || '',
                category: category,
                title: title || (existing === null || existing === void 0 ? void 0 : existing.title) || '',
                description: description !== '' ? description : (existing === null || existing === void 0 ? void 0 : existing.description) || '',
                image: null,
                price: price,
                web3_ticker: listing.web3_ticker || (existing === null || existing === void 0 ? void 0 : existing.web3_ticker) || '',
                web3_amount: listing.web3_amount || (existing === null || existing === void 0 ? void 0 : existing.web3_amount) || '',
                quantity_available: available,
                quantity_total: available,
                listing_signature: listing.signature || '',
                updated_at: now,
                status: available > 0 ? 1 : 0
              });
              key = summaryBucketKey(nft_id, price);
              this.summaries[key] = summary;
              this.mod.summaries = this.summaries;
              syncSummaryCache(this.mod, summary);
              return _context32.a(2, summary);
          }
        }, _callee32, this);
      }));
      function _applyListingToSummary(_x29) {
        return _applyListingToSummary3.apply(this, arguments);
      }
      return _applyListingToSummary;
    }()
  }, {
    key: "extractListingMetadata",
    value: function extractListingMetadata() {
      var _ref9, _listing$description;
      var txmsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var listing = txmsg.listing || {};
      return {
        title: String(listing.title || txmsg.title || '').trim(),
        description: String((_ref9 = (_listing$description = listing.description) !== null && _listing$description !== void 0 ? _listing$description : txmsg.description) !== null && _ref9 !== void 0 ? _ref9 : '').trim()
      };
    }
  }, {
    key: "persistSummaryMetadata",
    value: function () {
      var _persistSummaryMetadata = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee34(nft_id, price) {
        var _this5 = this;
        var txmsg,
          _args34 = arguments;
        return _regenerator().w(function (_context34) {
          while (1) switch (_context34.n) {
            case 0:
              txmsg = _args34.length > 2 && _args34[2] !== undefined ? _args34[2] : {};
              return _context34.a(2, this.withSummaryMutation(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33() {
                var _this5$extractListing, title, description;
                return _regenerator().w(function (_context33) {
                  while (1) switch (_context33.n) {
                    case 0:
                      _this5$extractListing = _this5.extractListingMetadata(txmsg), title = _this5$extractListing.title, description = _this5$extractListing.description;
                      if (!(!title && !description)) {
                        _context33.n = 1;
                        break;
                      }
                      return _context33.a(2);
                    case 1:
                      _context33.n = 2;
                      return _this5.db.updateSummaryMetadata(nft_id, price, {
                        title: title,
                        description: description
                      });
                    case 2:
                      _context33.n = 3;
                      return _this5._syncSummaryToCache(nft_id, price);
                    case 3:
                      return _context33.a(2);
                  }
                }, _callee33);
              }))));
          }
        }, _callee34, this);
      }));
      function persistSummaryMetadata(_x30, _x31) {
        return _persistSummaryMetadata.apply(this, arguments);
      }
      return persistSummaryMetadata;
    }()
  }, {
    key: "persistSummaryCategory",
    value: function () {
      var _persistSummaryCategory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee36(listing) {
        var _this6 = this;
        return _regenerator().w(function (_context36) {
          while (1) switch (_context36.n) {
            case 0:
              return _context36.a(2, this.withSummaryMutation(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee35() {
                var category;
                return _regenerator().w(function (_context35) {
                  while (1) switch (_context35.n) {
                    case 0:
                      if (listing !== null && listing !== void 0 && listing.nft_id) {
                        _context35.n = 1;
                        break;
                      }
                      return _context35.a(2);
                    case 1:
                      category = listing.category || STORE_CATEGORIES.OTHER;
                      _context35.n = 2;
                      return _this6.db.updateSummaryCategory(listing.nft_id, listing.price, category);
                    case 2:
                      _context35.n = 3;
                      return _this6._syncSummaryToCache(listing.nft_id, listing.price);
                    case 3:
                      return _context35.a(2);
                  }
                }, _callee35);
              }))));
          }
        }, _callee36, this);
      }));
      function persistSummaryCategory(_x32) {
        return _persistSummaryCategory.apply(this, arguments);
      }
      return persistSummaryCategory;
    }()
  }, {
    key: "syncSummaryToCache",
    value: function () {
      var _syncSummaryToCache2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee37(nft_id, price) {
        var _this7 = this;
        return _regenerator().w(function (_context37) {
          while (1) switch (_context37.n) {
            case 0:
              return _context37.a(2, this.withSummaryMutation(function () {
                return _this7._syncSummaryToCache(nft_id, price);
              }));
          }
        }, _callee37, this);
      }));
      function syncSummaryToCache(_x33, _x34) {
        return _syncSummaryToCache2.apply(this, arguments);
      }
      return syncSummaryToCache;
    }()
  }, {
    key: "_syncSummaryToCache",
    value: function () {
      var _syncSummaryToCache3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee38(nft_id, price) {
        var row, summary, listing, key;
        return _regenerator().w(function (_context38) {
          while (1) switch (_context38.n) {
            case 0:
              _context38.n = 1;
              return this.db.returnSummaryByBucket(nft_id, price);
            case 1:
              row = _context38.v;
              if (row) {
                _context38.n = 2;
                break;
              }
              return _context38.a(2, null);
            case 2:
              summary = new Summary(this.app, this.mod, row);
              _context38.n = 3;
              return this.db.returnActiveListingForBucket(nft_id, price);
            case 3:
              listing = _context38.v;
              if (listing !== null && listing !== void 0 && listing.signature) {
                summary.listing_signature = listing.signature;
              }
              if (listing !== null && listing !== void 0 && listing.category) {
                summary.category = listing.category;
              }
              key = summaryBucketKey(nft_id, price);
              this.summaries[key] = summary;
              this.mod.summaries = this.summaries;
              syncSummaryCache(this.mod, summary);
              return _context38.a(2, summary);
          }
        }, _callee38, this);
      }));
      function _syncSummaryToCache(_x35, _x36) {
        return _syncSummaryToCache3.apply(this, arguments);
      }
      return _syncSummaryToCache;
    }()
  }, {
    key: "observeListingFromTransaction",
    value: function observeListingFromTransaction(nft, tx, txmsg) {
      var _blk$id6, _blk$hash5, _this$app$wallet$conv, _meta$price, _inventory_triple$, _tx$from, _tx$from2, _ref10, _ref11, _inventory_triple$2;
      var blk = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var signature = (tx === null || tx === void 0 ? void 0 : tx.signature) || '';
      var created_tuples = returnCreatedNftTuples(tx);
      if (!created_tuples.length) {
        console.warn('Store: observeListingFromTransaction: no NFT tuple created', signature);
        return null;
      }
      var script_address = txmsg.p2sh_address || '';
      if (!script_address) {
        console.warn('Store: observeListingFromTransaction: malformed transaction (missing p2sh_address)', signature);
        return null;
      }
      var slip_key = slipPublicKey(this.app, script_address);
      var listed_block_id = Number((_blk$id6 = blk === null || blk === void 0 ? void 0 : blk.id) !== null && _blk$id6 !== void 0 ? _blk$id6 : 0);
      var listed_block_hash = String((_blk$hash5 = blk === null || blk === void 0 ? void 0 : blk.hash) !== null && _blk$hash5 !== void 0 ? _blk$hash5 : '');
      var listed_transaction_id = transactionIndexInBlock(blk, tx);
      var inventory_triple = findInventoryTriple(tx.to, slip_key);
      if (!inventory_triple) {
        console.warn('Store: observeListingFromTransaction: inventory triple missing', signature, {
          slip_key: slip_key
        });
        return null;
      }
      var meta = txmsg.listing || {};
      var fulfill = txmsg.fulfill_sale || {};
      var web3_ticker = String(meta.web3_ticker || '').trim().toUpperCase();
      var web3_amount = String(meta.web3_amount || '').trim();
      var web3_sale = web3_ticker !== '' && web3_ticker !== 'SAITO';
      var price_nolan = web3_sale ? 0 : Number((_this$app$wallet$conv = this.app.wallet.convertSaitoToNolan((_meta$price = meta.price) !== null && _meta$price !== void 0 ? _meta$price : 0)) !== null && _this$app$wallet$conv !== void 0 ? _this$app$wallet$conv : 0);
      var change_qty = (_inventory_triple$ = inventory_triple[0]) === null || _inventory_triple$ === void 0 ? void 0 : _inventory_triple$.amount;

      // Bound from[0] is mint creator metadata; ownership is Normal/ATR from[1].
      var from0 = (_tx$from = tx.from) === null || _tx$from === void 0 ? void 0 : _tx$from[0];
      var from1 = (_tx$from2 = tx.from) === null || _tx$from2 === void 0 ? void 0 : _tx$from2[1];
      var listing_seller = (from0 === null || from0 === void 0 ? void 0 : from0.publicKey) || '';
      if ((from0 === null || from0 === void 0 ? void 0 : from0.type) === SlipType.Bound && from1 !== null && from1 !== void 0 && from1.publicKey) {
        listing_seller = from1.publicKey;
      }
      var nft_type = (typeof (nft === null || nft === void 0 ? void 0 : nft.returnType) === 'function' ? nft.returnType() : null) || (nft === null || nft === void 0 ? void 0 : nft.nft_type) || '';
      var category = mapNFTTypeToCategory(nft_type);
      return {
        signature: tx.signature,
        nft_id: String(nft.id || nft.uuid || meta.nft_id || ''),
        seller: fulfill.seller || listing_seller || '',
        category: category,
        quantity: Number((_ref10 = (_ref11 = change_qty !== null && change_qty !== void 0 ? change_qty : nft.amount) !== null && _ref11 !== void 0 ? _ref11 : (_inventory_triple$2 = inventory_triple[0]) === null || _inventory_triple$2 === void 0 ? void 0 : _inventory_triple$2.amount) !== null && _ref10 !== void 0 ? _ref10 : 1) || 1,
        price: price_nolan,
        web3_ticker: web3_sale ? web3_ticker : '',
        web3_amount: web3_sale ? web3_amount || String(meta.price || '').trim() : '',
        access_hash: txmsg.access_hash || '',
        access_script: txmsg.access_script || '',
        p2sh_address: script_address,
        block_id_listed: listed_block_id,
        block_hash_listed: listed_block_hash,
        transaction_id_listed: listed_transaction_id,
        longest_chain_listed: 1,
        block_id_sold: 0,
        block_hash_sold: '',
        transaction_id_sold: 0,
        longest_chain_sold: 0,
        settlement_pending: 0,
        slip_id: returnListingSlipId(tx, slip_key),
        on_chain: 1,
        utxo_slip1: serializeSlip(inventory_triple[0]),
        utxo_slip2: serializeSlip(inventory_triple[1]),
        utxo_slip3: serializeSlip(inventory_triple[2]),
        created_at: Date.now(),
        updated_at: Date.now()
      };
    }
  }, {
    key: "matchSpentListings",
    value: function () {
      var _matchSpentListings = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee39(tx) {
        var spent_tuples, rows, spent, _iterator26, _step26, row, listing_row, _t41;
        return _regenerator().w(function (_context39) {
          while (1) switch (_context39.p = _context39.n) {
            case 0:
              spent_tuples = returnSpentNftTuples(tx);
              if (spent_tuples.length) {
                _context39.n = 1;
                break;
              }
              return _context39.a(2, []);
            case 1:
              _context39.n = 2;
              return this.db.returnAllActiveListingRows();
            case 2:
              rows = _context39.v;
              spent = [];
              _iterator26 = _createForOfIteratorHelper(rows || []);
              _context39.p = 3;
              _iterator26.s();
            case 4:
              if ((_step26 = _iterator26.n()).done) {
                _context39.n = 7;
                break;
              }
              row = _step26.value;
              listing_row = new Listing(row);
              if (!listing_row.isSoldOnChain()) {
                _context39.n = 5;
                break;
              }
              return _context39.a(3, 6);
            case 5:
              if (this.listingOutpointsSpentBy(row, tx)) {
                spent.push(row);
              }
            case 6:
              _context39.n = 4;
              break;
            case 7:
              _context39.n = 9;
              break;
            case 8:
              _context39.p = 8;
              _t41 = _context39.v;
              _iterator26.e(_t41);
            case 9:
              _context39.p = 9;
              _iterator26.f();
              return _context39.f(9);
            case 10:
              return _context39.a(2, spent);
          }
        }, _callee39, this, [[3, 8, 9, 10]]);
      }));
      function matchSpentListings(_x37) {
        return _matchSpentListings.apply(this, arguments);
      }
      return matchSpentListings;
    }()
  }, {
    key: "returnAvailableQuantity",
    value: function () {
      var _returnAvailableQuantity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee40(nft_id, price) {
        return _regenerator().w(function (_context40) {
          while (1) switch (_context40.n) {
            case 0:
              return _context40.a(2, this.db.sumListingQuantityForBucket(nft_id, price));
          }
        }, _callee40, this);
      }));
      function returnAvailableQuantity(_x38, _x39) {
        return _returnAvailableQuantity.apply(this, arguments);
      }
      return returnAvailableQuantity;
    }()
  }, {
    key: "syncSummaryForBucket",
    value: function () {
      var _syncSummaryForBucket2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee41(nft_id, price) {
        var _this8 = this;
        return _regenerator().w(function (_context41) {
          while (1) switch (_context41.n) {
            case 0:
              return _context41.a(2, this.withSummaryMutation(function () {
                return _this8._syncSummaryForBucket(nft_id, price);
              }));
          }
        }, _callee41, this);
      }));
      function syncSummaryForBucket(_x40, _x41) {
        return _syncSummaryForBucket2.apply(this, arguments);
      }
      return syncSummaryForBucket;
    }()
  }, {
    key: "_syncSummaryForBucket",
    value: function () {
      var _syncSummaryForBucket3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee42(nft_id, price) {
        var available, row, now, refreshed, has_metadata, key;
        return _regenerator().w(function (_context42) {
          while (1) switch (_context42.n) {
            case 0:
              _context42.n = 1;
              return this.db.sumListingQuantityForBucket(nft_id, price);
            case 1:
              available = _context42.v;
              _context42.n = 2;
              return this.db.returnSummaryByBucket(nft_id, price);
            case 2:
              row = _context42.v;
              if (!(!row && available <= 0)) {
                _context42.n = 3;
                break;
              }
              return _context42.a(2, null);
            case 3:
              now = Date.now();
              if (row) {
                _context42.n = 6;
                break;
              }
              _context42.n = 4;
              return this.db.insertSummary({
                nft_id: nft_id,
                price: Number(price !== null && price !== void 0 ? price : 0),
                category: STORE_CATEGORIES.OTHER,
                title: '',
                description: '',
                image: null,
                quantity_available: available,
                updated_at: now
              });
            case 4:
              _context42.n = 5;
              return this.db.returnSummaryByBucket(nft_id, price);
            case 5:
              row = _context42.v;
              _context42.n = 10;
              break;
            case 6:
              _context42.n = 7;
              return this.db.updateSummaryAvailableByBucket(nft_id, price, available, now);
            case 7:
              if (!(available <= 0)) {
                _context42.n = 10;
                break;
              }
              _context42.n = 8;
              return this.db.returnSummaryByBucket(nft_id, price);
            case 8:
              refreshed = _context42.v;
              has_metadata = !!(refreshed !== null && refreshed !== void 0 && refreshed.title || refreshed !== null && refreshed !== void 0 && refreshed.description);
              if (has_metadata) {
                _context42.n = 10;
                break;
              }
              _context42.n = 9;
              return this.db.deleteSummaryByBucket(nft_id, price);
            case 9:
              key = summaryBucketKey(nft_id, price);
              delete this.summaries[key];
              this.mod.summaries = this.summaries;
              return _context42.a(2, null);
            case 10:
              return _context42.a(2, this._syncSummaryToCache(nft_id, price));
          }
        }, _callee42, this);
      }));
      function _syncSummaryForBucket(_x42, _x43) {
        return _syncSummaryForBucket3.apply(this, arguments);
      }
      return _syncSummaryForBucket;
    }() /** True when this exact block inclusion of the listing transaction is already stored. */
  }, {
    key: "listingExists",
    value: function () {
      var _listingExists = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee43(signature) {
        var block_hash_listed,
          _args43 = arguments;
        return _regenerator().w(function (_context43) {
          while (1) switch (_context43.n) {
            case 0:
              block_hash_listed = _args43.length > 1 && _args43[1] !== undefined ? _args43[1] : '';
              if (signature) {
                _context43.n = 1;
                break;
              }
              return _context43.a(2, false);
            case 1:
              if (!this.listings[this.listingCacheKey(signature, block_hash_listed)]) {
                _context43.n = 2;
                break;
              }
              return _context43.a(2, true);
            case 2:
              _context43.n = 3;
              return this.db.returnListingBySignatureAndBlockHash(signature, block_hash_listed);
            case 3:
              return _context43.a(2, !!_context43.v);
          }
        }, _callee43, this);
      }));
      function listingExists(_x44) {
        return _listingExists.apply(this, arguments);
      }
      return listingExists;
    }()
  }]);
}();
module.exports = Warehouse;